var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Download, Search } from '@mui/icons-material';
import { Box, Chip, CircularProgress, Stack, Typography, useMediaQuery } from '@mui/material';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CustomerCardEditIcon, DropDownIconNew, PlusHeaderIcon } from '../../assets/customIcons';
import { ArrowUPIcon, ShareIcon } from '../../assets/images';
import { ReactComponent as LocationIcon } from '../../assets/images/LocationIcon.svg';
import { ReactComponent as LeftArrow } from '../../assets/images/arrow-left.svg';
import { ReactComponent as CheckSVGIcon } from '../../assets/images/check-circle.svg';
import { ReactComponent as VerifiedIcon } from '../../assets/images/check-verified.svg';
import { ReactComponent as RightArrow } from '../../assets/images/chevron-right.svg';
import { ReactComponent as LinkSvg } from '../../assets/images/linkIcon.svg';
import { DynamicFormBuilderContainer } from '../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { SignatureIndex } from '../../components/atoms/signature/Signature';
import { showSurface } from '../../redux/awaitedSurfacesSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { MailIconSVG, PrintIconSVG } from '../spareParts/purchaseRequistion/assets/customIcons';
import { AccountPosting } from './components/accountPosting';
import PaymentReceivePopup from './components/paymentReceivePopup';
import { executiveListAPI, getContractSaleOrderAPI, getCustomerDetailsAPI, InstallBaseListAPI, paymentModeListAPI, searchByMobileNoAPI, searchByOrderNoAPI } from './services/apiCall';
import { ActiveContractURL, ContractInvoiceKeys, JSIAttachmentAPIKeys, JsiAttachmentCreateAPI, JsiAttachmentUploadAPI, NewContractURL, UpsertNewContractURL } from './services/entity';
import dayjs from 'dayjs';
import { ReactComponent as CloseIcon } from '../../assets/images/close.svg';
import { LOCAL_STORAGE_KEYS } from '../../constants';
import { showNotification } from '../../redux/commonSlice';
import { createAPI, getByIdAPI, getListAPI, uploadAttachmentAPI } from '../../redux/crudSlice';
import { getLocalStorageItem } from '../../utils/storageHelper';
import { dataURLtoFile } from '../../utils/utils';
import ContractDetailsDrawer from './components/contractDetailsDrawer';
import DiscardInvoicePopup from './components/discardInvoicePopup';
import InvoiceSavedPopup from './components/invoiceSavedPopup';
import { InvoiceSummaryPopup } from './components/invoiceSummaryPopup';
import { getLoadingKey } from '../../builderPackage/common/commonFunctions';
import { VehicleHistory } from '../vehicleHistory/pages/vehicleHistory';
var NewContractSaleInvoice = function (props) {
    var _getLocalStorageItem, _getLocalStorageItem2, _crud$ContractInvoice, _crud$ContractInvoice2, _crud$ContractInvoice3, _crud$ContractInvoice5, _crud$ContractInvoice6, _crud$ContractInvoice7, _crud$ContractInvoice8, _customerPrimaryConta, _crud$ContractInvoice9, _crud$ContractInvoice10, _crud$ContractInvoice11, _crud$ContractInvoice12, _customerPrimaryConta2, _customerSecondaryCon, _crud$ContractInvoice13, _crud$ContractInvoice14, _crud$ContractInvoice15, _crud$ContractInvoice16, _crud$ContractInvoice17;
    var IS_MOBILE = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var signature = useAppSelector(function (state) { return state.crud; }).signature;
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var dispatch = useAppDispatch();
    var isDisabled = props.isDisabled;
    var id = useParams().id;
    var navigate = useNavigate();
    var crud = useAppSelector(function (state) { return state.crud; });
    var UserOrganizationID = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var ParentOrganizationID = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.Branches[0]) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.ParentOrganizationId;
    var isSearchLoading = [crud[getLoadingKey(ContractInvoiceKeys.SearchByMobNoKey)], crud[getLoadingKey(ContractInvoiceKeys.InstallBaseListKey)], crud[getLoadingKey(ContractInvoiceKeys.CustomerDetailsKey)], crud[getLoadingKey(ContractInvoiceKeys.ActiveContracts)], crud[getLoadingKey(ContractInvoiceKeys.NewContractKey)]].includes('loading');
    var searchType = [{
            id: 'RegistrationNo',
            label: 'Reg. No'
        }, {
            id: 'OrderNo',
            label: 'Order No'
        }, {
            id: 'VinNo',
            label: 'Vin. No'
        }, {
            id: 'Mobile',
            label: 'Mobile'
        }
        // { id: 'Email', label: 'Email' },
    ];
    var handleClickSearch = function (state, value) { return __awaiter(void 0, void 0, void 0, function () {
        var _getInstallbaseData7, _getContractOrderdata, ResponseData, getInstallbaseData, getCustomerData, getContractOrderdata, _getInstallbaseData, _getInstallbaseData2, _getInstallbaseData3, _ResponseData, _getInstallbaseData4, _getInstallbaseData5, _ResponseData2, _getInstallbaseData6, _ResponseData3, _ResponseData4, _ResponseData5, _ResponseData6, existingInstallbase, ContractOrderdata, _getInstallbaseData8, _getInstallbaseData9, _getContractOrderdata2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(state.Key === 'VinNo' || state.Key === "RegistrationNo" && state !== null && state !== void 0 && state.Value)) return [3 /*break*/, 4];
                    return [4 /*yield*/, InstallBaseListAPI({
                            request: {
                                Value: state === null || state === void 0 ? void 0 : state.Value,
                                Key: state === null || state === void 0 ? void 0 : state.Key
                            }
                        })];
                case 1:
                    getInstallbaseData = _a.sent();
                    if (!(((_getInstallbaseData = getInstallbaseData) === null || _getInstallbaseData === void 0 ? void 0 : _getInstallbaseData.statusCode) == 200 && (_getInstallbaseData2 = getInstallbaseData) !== null && _getInstallbaseData2 !== void 0 && _getInstallbaseData2.success)) return [3 /*break*/, 3];
                    return [4 /*yield*/, getCustomerDetailsAPI({
                            request: {
                                id: (_getInstallbaseData3 = getInstallbaseData) === null || _getInstallbaseData3 === void 0 || (_getInstallbaseData3 = _getInstallbaseData3.data) === null || _getInstallbaseData3 === void 0 || (_getInstallbaseData3 = _getInstallbaseData3.Customer) === null || _getInstallbaseData3 === void 0 ? void 0 : _getInstallbaseData3.CustomerId
                            }
                        })];
                case 2:
                    getCustomerData = _a.sent();
                    _a.label = 3;
                case 3: return [3 /*break*/, 13];
                case 4:
                    if (!((state === null || state === void 0 ? void 0 : state.Key) === 'Mobile' && state !== null && state !== void 0 && state.Value)) return [3 /*break*/, 10];
                    return [4 /*yield*/, searchByMobileNoAPI({
                            request: {
                                MobileNumber: state === null || state === void 0 ? void 0 : state.Value
                            }
                        })];
                case 5:
                    ResponseData = _a.sent();
                    if (!(ResponseData.statusCode == 200 && ResponseData.success && ((_ResponseData = ResponseData) === null || _ResponseData === void 0 || (_ResponseData = _ResponseData.data) === null || _ResponseData === void 0 ? void 0 : _ResponseData.length) > 0)) return [3 /*break*/, 7];
                    return [4 /*yield*/, InstallBaseListAPI({
                            request: {
                                Value: (_ResponseData2 = ResponseData) === null || _ResponseData2 === void 0 || (_ResponseData2 = _ResponseData2.data[0]) === null || _ResponseData2 === void 0 ? void 0 : _ResponseData2.PersonId,
                                Key: 'PersonId'
                            }
                        })];
                case 6:
                    getInstallbaseData = _a.sent();
                    _a.label = 7;
                case 7:
                    if (!(((_getInstallbaseData4 = getInstallbaseData) === null || _getInstallbaseData4 === void 0 ? void 0 : _getInstallbaseData4.statusCode) == 200 && (_getInstallbaseData5 = getInstallbaseData) !== null && _getInstallbaseData5 !== void 0 && _getInstallbaseData5.success)) return [3 /*break*/, 9];
                    return [4 /*yield*/, getCustomerDetailsAPI({
                            request: {
                                id: (_getInstallbaseData6 = getInstallbaseData) === null || _getInstallbaseData6 === void 0 || (_getInstallbaseData6 = _getInstallbaseData6.data) === null || _getInstallbaseData6 === void 0 || (_getInstallbaseData6 = _getInstallbaseData6.Customer) === null || _getInstallbaseData6 === void 0 ? void 0 : _getInstallbaseData6.CustomerId
                            }
                        })];
                case 8:
                    getCustomerData = _a.sent();
                    _a.label = 9;
                case 9: return [3 /*break*/, 13];
                case 10:
                    if (!((state === null || state === void 0 ? void 0 : state.Key) === 'OrderNo' && state !== null && state !== void 0 && state.Value)) return [3 /*break*/, 13];
                    return [4 /*yield*/, searchByOrderNoAPI({
                            request: {
                                OrganizationId: UserOrganizationID,
                                ParentOrganizationId: ParentOrganizationID,
                                search: state.Value
                            }
                        })];
                case 11:
                    ResponseData = _a.sent();
                    if (!(((_ResponseData3 = ResponseData) === null || _ResponseData3 === void 0 ? void 0 : _ResponseData3.statusCode) == 200 && (_ResponseData4 = ResponseData) !== null && _ResponseData4 !== void 0 && _ResponseData4.success && ((_ResponseData5 = ResponseData) === null || _ResponseData5 === void 0 || (_ResponseData5 = _ResponseData5.data) === null || _ResponseData5 === void 0 ? void 0 : _ResponseData5.length) > 0)) return [3 /*break*/, 13];
                    return [4 /*yield*/, getContractSaleOrderAPI({
                            key: 'ContractSaleOrderKey',
                            request: {
                                id: (_ResponseData6 = ResponseData) === null || _ResponseData6 === void 0 || (_ResponseData6 = _ResponseData6.data[0]) === null || _ResponseData6 === void 0 ? void 0 : _ResponseData6.OrderId
                            }
                        })];
                case 12:
                    getContractOrderdata = _a.sent();
                    _a.label = 13;
                case 13:
                    existingInstallbase = ((_getInstallbaseData7 = getInstallbaseData) === null || _getInstallbaseData7 === void 0 || (_getInstallbaseData7 = _getInstallbaseData7.data) === null || _getInstallbaseData7 === void 0 ? void 0 : _getInstallbaseData7.InstallBase) || [];
                    ContractOrderdata = ((_getContractOrderdata = getContractOrderdata) === null || _getContractOrderdata === void 0 || (_getContractOrderdata = _getContractOrderdata.data) === null || _getContractOrderdata === void 0 ? void 0 : _getContractOrderdata.VehicleContractDetails) || [];
                    if ((existingInstallbase === null || existingInstallbase === void 0 ? void 0 : existingInstallbase.length) > 0) {
                        return [2 /*return*/, _objectSpread(_objectSpread({}, (_getInstallbaseData8 = getInstallbaseData) === null || _getInstallbaseData8 === void 0 ? void 0 : _getInstallbaseData8.data), {}, {
                                InstallBase: existingInstallbase,
                                success: (_getInstallbaseData9 = getInstallbaseData) === null || _getInstallbaseData9 === void 0 ? void 0 : _getInstallbaseData9.success,
                                resultnotfound: false
                            })];
                    }
                    else if ((ContractOrderdata === null || ContractOrderdata === void 0 ? void 0 : ContractOrderdata.length) > 0) {
                        return [2 /*return*/, _objectSpread(_objectSpread({}, (_getContractOrderdata2 = getContractOrderdata) === null || _getContractOrderdata2 === void 0 ? void 0 : _getContractOrderdata2.data), {}, {
                                VehicleContractDetails: ContractOrderdata,
                                success: true,
                                resultnotfound: false
                            })];
                    }
                    else {
                        return [2 /*return*/, {
                                resultnotfound: true,
                                success: false
                            }];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var customerPrimaryContactNo = (_crud$ContractInvoice = crud[ContractInvoiceKeys.CustomerDetailsKey]) === null || _crud$ContractInvoice === void 0 || (_crud$ContractInvoice = _crud$ContractInvoice.data) === null || _crud$ContractInvoice === void 0 || (_crud$ContractInvoice = _crud$ContractInvoice.PersonContact) === null || _crud$ContractInvoice === void 0 ? void 0 : _crud$ContractInvoice.find(function (contact) { return (contact === null || contact === void 0 ? void 0 : contact.ContactType) === "Primary"; });
    var customerSecondaryContactNo = (_crud$ContractInvoice2 = crud[ContractInvoiceKeys.CustomerDetailsKey]) === null || _crud$ContractInvoice2 === void 0 || (_crud$ContractInvoice2 = _crud$ContractInvoice2.data) === null || _crud$ContractInvoice2 === void 0 || (_crud$ContractInvoice2 = _crud$ContractInvoice2.PersonContact) === null || _crud$ContractInvoice2 === void 0 ? void 0 : _crud$ContractInvoice2.find(function (contact) { return (contact === null || contact === void 0 ? void 0 : contact.ContactType) === "Secondary"; });
    var customerEmail = (_crud$ContractInvoice3 = crud[ContractInvoiceKeys.CustomerDetailsKey]) === null || _crud$ContractInvoice3 === void 0 || (_crud$ContractInvoice3 = _crud$ContractInvoice3.data) === null || _crud$ContractInvoice3 === void 0 || (_crud$ContractInvoice3 = _crud$ContractInvoice3.PersonContact) === null || _crud$ContractInvoice3 === void 0 ? void 0 : _crud$ContractInvoice3.find(function (email) { return (email === null || email === void 0 ? void 0 : email.Email) === "Primary"; });
    var clickOnDiscard = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var MenuList;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(showSurface({
                        type: 'Dialog',
                        Component: DiscardInvoicePopup,
                        containerProps: {
                            maxWidth: 'xs'
                        },
                        componentProps: {
                            onClose: function () { }
                        }
                    }))];
                case 1:
                    MenuList = _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var accountPosting = [{
            type: FormItemTypes.Custom,
            name: 'AccountPosting',
            element: AccountPosting,
            columnSize: 12
        }];
    var generalFields = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            sx: {
                overflow: 'scroll'
            },
            elements: [{
                    type: FormItemTypes.Box,
                    name: '',
                    columnSize: 0,
                    display: 'flex',
                    bgcolor: 'white',
                    padding: '8px',
                    gap: '20px',
                    alignItems: 'center',
                    borderRadius: '8px',
                    setFieldProps: function (state) {
                        var _ref, _crud$ContractInvoice4;
                        return {
                            type: FormItemTypes.Box,
                            name: '',
                            elements: (_ref = (state === null || state === void 0 ? void 0 : state.Key) === "OrderNo" ? state === null || state === void 0 ? void 0 : state.VehicleContractDetails : id ? (_crud$ContractInvoice4 = crud[ContractInvoiceKeys.getCSI]) === null || _crud$ContractInvoice4 === void 0 || (_crud$ContractInvoice4 = _crud$ContractInvoice4.data) === null || _crud$ContractInvoice4 === void 0 ? void 0 : _crud$ContractInvoice4.VehicleContractDetails : state === null || state === void 0 ? void 0 : state.InstallBase) === null || _ref === void 0 ? void 0 : _ref.map(function (data, index) {
                                var _state$VehicleContrac, _state$VehicleContrac2;
                                return {
                                    type: FormItemTypes.Box,
                                    name: 'vehicleNumber',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    columnSize: 0,
                                    borderRadius: '8px',
                                    padding: '6px 12px',
                                    setFieldProps: function (state, value) {
                                        return {
                                            type: FormItemTypes.Box,
                                            bgcolor: (state === null || state === void 0 ? void 0 : state.selectedVehicle) === (data === null || data === void 0 ? void 0 : data.RegistrationNo) ? 'secondary.100' : 'transparent'
                                        };
                                    },
                                    elements: [{
                                            type: FormItemTypes.CheckBox,
                                            label: '',
                                            name: "vehicle-".concat(data === null || data === void 0 ? void 0 : data.InstallBaseId),
                                            columnSize: 0,
                                            sx: {
                                                padding: 0
                                            },
                                            formControlLabelProps: {
                                                sx: {
                                                    margin: 0
                                                }
                                            },
                                            setFormState: function (formValues, currValue) { return __awaiter(void 0, void 0, void 0, function () {
                                                var updatedDetails;
                                                return __generator(this, function (_a) {
                                                    updatedDetails = __spreadArray([], ((formValues === null || formValues === void 0 ? void 0 : formValues.VehicleContractDetails) || []), true);
                                                    if (currValue) {
                                                        updatedDetails.push({
                                                            VinNo: data === null || data === void 0 ? void 0 : data.VinNo,
                                                            RegistrationNo: data === null || data === void 0 ? void 0 : data.RegistrationNo,
                                                            InstallBaseId: data === null || data === void 0 ? void 0 : data.InstallBaseId,
                                                            isSelected: true,
                                                            id: data === null || data === void 0 ? void 0 : data.InstallBaseId
                                                        });
                                                    }
                                                    else {
                                                        updatedDetails = updatedDetails.filter(function (item) { return item.InstallBaseId !== data.InstallBaseId; });
                                                    }
                                                    return [2 /*return*/, {
                                                            VehicleContractDetails: updatedDetails
                                                        }];
                                                });
                                            }); },
                                            valueGetter: function (formValues) {
                                                return ((formValues === null || formValues === void 0 ? void 0 : formValues.VehicleContractDetails) || []).some(function (item) { return (item === null || item === void 0 ? void 0 : item.RegistrationNo) === (data === null || data === void 0 ? void 0 : data.RegistrationNo); });
                                            }
                                        }, {
                                            type: FormItemTypes.Button,
                                            name: '',
                                            variant: 'text',
                                            children: isSearchLoading ? /*#__PURE__*/ React.createElement(CircularProgress, {
                                                size: 16
                                            }) : data === null || data === void 0 ? void 0 : data.RegistrationNo,
                                            color: 'info',
                                            columnSize: 0,
                                            sx: {
                                                p: 0,
                                                gap: '20px',
                                                color: 'secondary.900'
                                            },
                                            disabled: !((state === null || state === void 0 ? void 0 : state.VehicleContractDetails) || []).some(function (item) { return (item === null || item === void 0 ? void 0 : item.RegistrationNo) === (data === null || data === void 0 ? void 0 : data.RegistrationNo); }),
                                            setFormState: function (formValues) { return __awaiter(void 0, void 0, void 0, function () {
                                                var _res$payload, _newContractRes$paylo, res, newContractRes, updatedActiveContracts, updatedNewContracts;
                                                return __generator(this, function (_a) {
                                                    switch (_a.label) {
                                                        case 0: return [4 /*yield*/, dispatch(getListAPI({
                                                                key: ContractInvoiceKeys.ActiveContracts,
                                                                url: ActiveContractURL,
                                                                request: {
                                                                    InstallBaseId: data === null || data === void 0 ? void 0 : data.InstallBaseId
                                                                }
                                                            }))];
                                                        case 1:
                                                            res = _a.sent();
                                                            return [4 /*yield*/, dispatch(getByIdAPI({
                                                                    key: ContractInvoiceKeys.NewContractKey,
                                                                    url: NewContractURL,
                                                                    request: {}
                                                                }))];
                                                        case 2:
                                                            newContractRes = _a.sent();
                                                            updatedActiveContracts = (res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.value) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 ? void 0 : _res$payload.map(function (contract) {
                                                                var _contract$ContractPri, _contract$Price, _contract$ContractPri2, _contract$ContractPri3, _formValues$InstallBa;
                                                                return _objectSpread(_objectSpread({}, contract), {}, {
                                                                    ContractPrice: (_contract$ContractPri = contract === null || contract === void 0 ? void 0 : contract.ContractPrice) !== null && _contract$ContractPri !== void 0 ? _contract$ContractPri : 0,
                                                                    Rate: (_contract$Price = contract === null || contract === void 0 ? void 0 : contract.Price) !== null && _contract$Price !== void 0 ? _contract$Price : 0,
                                                                    DiscountPercentage: 0,
                                                                    DiscountAmount: 0,
                                                                    ChargesAmount: 0,
                                                                    TaxableAmount: (_contract$ContractPri2 = contract === null || contract === void 0 ? void 0 : contract.ContractPrice) !== null && _contract$ContractPri2 !== void 0 ? _contract$ContractPri2 : 0,
                                                                    UnitOfMeasurementId: null,
                                                                    PostingTypeId: null,
                                                                    TotalAmount: (_contract$ContractPri3 = contract === null || contract === void 0 ? void 0 : contract.ContractPrice) !== null && _contract$ContractPri3 !== void 0 ? _contract$ContractPri3 : 0,
                                                                    Quantity: 1,
                                                                    SGST_UTGST_Percentage: 0,
                                                                    SGST_UTGST_Amount: 0,
                                                                    CGSTAmount: 0,
                                                                    CGSTPercentage: 0,
                                                                    IGSTAmount: 0,
                                                                    IGSTPercentage: 0,
                                                                    SystemName: 'ServiceContract',
                                                                    ChildId: id ? contract === null || contract === void 0 ? void 0 : contract.ChildId : contract === null || contract === void 0 ? void 0 : contract.id,
                                                                    EntityId: id ? contract === null || contract === void 0 ? void 0 : contract.EntityId : formValues === null || formValues === void 0 || (_formValues$InstallBa = formValues.InstallBase[0]) === null || _formValues$InstallBa === void 0 ? void 0 : _formValues$InstallBa.SchemaId
                                                                });
                                                            })) || [];
                                                            updatedNewContracts = (newContractRes === null || newContractRes === void 0 || (_newContractRes$paylo = newContractRes.payload) === null || _newContractRes$paylo === void 0 || (_newContractRes$paylo = _newContractRes$paylo.value) === null || _newContractRes$paylo === void 0 || (_newContractRes$paylo = _newContractRes$paylo.data) === null || _newContractRes$paylo === void 0 ? void 0 : _newContractRes$paylo.map(function (contract) {
                                                                var _contract$ContractPri4, _contract$ContractPri5, _contract$ContractPri6, _contract$ContractPri7;
                                                                return _objectSpread(_objectSpread({}, contract), {}, {
                                                                    ContractPrice: (_contract$ContractPri4 = contract === null || contract === void 0 ? void 0 : contract.ContractPrice) !== null && _contract$ContractPri4 !== void 0 ? _contract$ContractPri4 : 0,
                                                                    Rate: (_contract$ContractPri5 = contract === null || contract === void 0 ? void 0 : contract.ContractPrice) !== null && _contract$ContractPri5 !== void 0 ? _contract$ContractPri5 : 0,
                                                                    DiscountPercentage: 0,
                                                                    DiscountAmount: 0,
                                                                    ChargesAmount: 0,
                                                                    TaxableAmount: (_contract$ContractPri6 = contract === null || contract === void 0 ? void 0 : contract.ContractPrice) !== null && _contract$ContractPri6 !== void 0 ? _contract$ContractPri6 : 0,
                                                                    UnitOfMeasurementId: null,
                                                                    PostingTypeId: null,
                                                                    TotalAmount: (_contract$ContractPri7 = contract === null || contract === void 0 ? void 0 : contract.ContractPrice) !== null && _contract$ContractPri7 !== void 0 ? _contract$ContractPri7 : 0,
                                                                    Quantity: 1,
                                                                    SGST_UTGST_Percentage: 0,
                                                                    SGST_UTGST_Amount: 0,
                                                                    CGSTAmount: 0,
                                                                    CGSTPercentage: 0,
                                                                    IGSTAmount: 0,
                                                                    IGSTPercentage: 0,
                                                                    SystemName: 'ServiceContract',
                                                                    ChildId: contract === null || contract === void 0 ? void 0 : contract.id
                                                                    // EntityId: id ? contract.EntityId : null,
                                                                });
                                                            })) || [];
                                                            return [2 /*return*/, {
                                                                    selectedVehicle: data === null || data === void 0 ? void 0 : data.RegistrationNo,
                                                                    ActiveContracts: updatedActiveContracts,
                                                                    NewContracts: updatedNewContracts,
                                                                    SelectedButton: 'New',
                                                                    EngineNo: data === null || data === void 0 ? void 0 : data.EngineNo,
                                                                    VinNo: data === null || data === void 0 ? void 0 : data.VinNo,
                                                                    RegistrationNo: data === null || data === void 0 ? void 0 : data.RegistrationNo,
                                                                    ModelName: data === null || data === void 0 ? void 0 : data.ModelName,
                                                                    SalesInvoiceDate: data === null || data === void 0 ? void 0 : data.SalesInvoiceDate,
                                                                    ProductName: data === null || data === void 0 ? void 0 : data.ProductName,
                                                                    ProductCode: id ? data === null || data === void 0 ? void 0 : data.ProductCode : data === null || data === void 0 ? void 0 : data.SKUCode
                                                                }];
                                                    }
                                                });
                                            }); },
                                            endIcon: /*#__PURE__*/ React.createElement(Stack, null, (state === null || state === void 0 || (_state$VehicleContrac = state.VehicleContractDetails) === null || _state$VehicleContrac === void 0 || (_state$VehicleContrac = _state$VehicleContrac.find(function (contract) { return (contract === null || contract === void 0 ? void 0 : contract.RegistrationNo) === (data === null || data === void 0 ? void 0 : data.RegistrationNo); })) === null || _state$VehicleContrac === void 0 || (_state$VehicleContrac = _state$VehicleContrac.Items) === null || _state$VehicleContrac === void 0 ? void 0 : _state$VehicleContrac.length) > 0 && /*#__PURE__*/ React.createElement(Chip, {
                                                color: "secondary",
                                                label: (state === null || state === void 0 || (_state$VehicleContrac2 = state.VehicleContractDetails) === null || _state$VehicleContrac2 === void 0 || (_state$VehicleContrac2 = _state$VehicleContrac2.find(function (contract) { return (contract === null || contract === void 0 ? void 0 : contract.RegistrationNo) === (data === null || data === void 0 ? void 0 : data.RegistrationNo); })) === null || _state$VehicleContrac2 === void 0 || (_state$VehicleContrac2 = _state$VehicleContrac2.Items) === null || _state$VehicleContrac2 === void 0 ? void 0 : _state$VehicleContrac2.length) || 0
                                            }))
                                        }]
                                };
                            })
                        };
                    }
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            setFieldProps: function (state) { return ({
                type: FormItemTypes.ContainerItem,
                sx: {
                    display: state !== null && state !== void 0 && state.selectedVehicle ? undefined : 'none'
                }
            }); },
            elements: [{
                    type: FormItemTypes.CardComponent,
                    name: '',
                    columnSize: 12,
                    sx: {
                        border: '1px',
                        borderRadius: "12px",
                        borderColor: "secondary.200"
                    },
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: true,
                            fontWeight: "strong",
                            children: 'Basic details',
                            color: "secondary.900"
                        }, {
                            type: FormItemTypes.IconButton,
                            name: '',
                            columnSize: 0,
                            children: isOpen ? /*#__PURE__*/ React.createElement("img", {
                                src: ArrowUPIcon,
                                alt: ""
                            }) : /*#__PURE__*/ React.createElement(DropDownIconNew, {
                                sx: {
                                    color: 'secondary.500'
                                }
                            }),
                            setFormState: function (formValues, currValue) {
                                if (isOpen) {
                                    setIsOpen(false);
                                }
                                else {
                                    setIsOpen(true);
                                }
                                return {};
                            }
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            spacing: 0,
                            rowGap: 1,
                            columnSpacing: 2,
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    xs: 12,
                                    sm: 6,
                                    md: 3,
                                    lg: 3,
                                    spacing: 1,
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            children: 'Customer details',
                                            fontSize: 'sm',
                                            fontWeight: 'medium',
                                            color: 'text.secondary',
                                            columnSize: 12
                                        }, !isOpen ? {
                                            type: FormItemTypes.CardComponent,
                                            name: '',
                                            sx: {
                                                p: 1.5
                                            },
                                            columnSize: 12,
                                            contentProps: {
                                                spacing: 0
                                            },
                                            elements: [{
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    columnSize: 12,
                                                    spacing: 0,
                                                    columnGap: 1,
                                                    alignItems: 'center',
                                                    flexWrap: 'nowrap',
                                                    elements: [{
                                                            type: FormItemTypes.Avatar,
                                                            name: '',
                                                            columnSize: 0,
                                                            sx: {
                                                                height: 24,
                                                                width: 24
                                                            }
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: '',
                                                            columnSize: 0,
                                                            value: "".concat((_crud$ContractInvoice5 = (_crud$ContractInvoice6 = crud[ContractInvoiceKeys.CustomerDetailsKey]) === null || _crud$ContractInvoice6 === void 0 || (_crud$ContractInvoice6 = _crud$ContractInvoice6.data) === null || _crud$ContractInvoice6 === void 0 || (_crud$ContractInvoice6 = _crud$ContractInvoice6.Person) === null || _crud$ContractInvoice6 === void 0 ? void 0 : _crud$ContractInvoice6.GivenName) !== null && _crud$ContractInvoice5 !== void 0 ? _crud$ContractInvoice5 : '-', " ").concat((_crud$ContractInvoice7 = (_crud$ContractInvoice8 = crud[ContractInvoiceKeys === null || ContractInvoiceKeys === void 0 ? void 0 : ContractInvoiceKeys.CustomerDetailsKey]) === null || _crud$ContractInvoice8 === void 0 || (_crud$ContractInvoice8 = _crud$ContractInvoice8.data) === null || _crud$ContractInvoice8 === void 0 || (_crud$ContractInvoice8 = _crud$ContractInvoice8.Person) === null || _crud$ContractInvoice8 === void 0 ? void 0 : _crud$ContractInvoice8.FamilyName) !== null && _crud$ContractInvoice7 !== void 0 ? _crud$ContractInvoice7 : ''),
                                                            fontWeight: 'medium'
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: '',
                                                            columnSize: true,
                                                            value: (_customerPrimaryConta = customerPrimaryContactNo === null || customerPrimaryContactNo === void 0 ? void 0 : customerPrimaryContactNo.MobileNumber) !== null && _customerPrimaryConta !== void 0 ? _customerPrimaryConta : '-',
                                                            fontSize: "sm",
                                                            color: 'text.secondary'
                                                        }, {
                                                            type: FormItemTypes.Icon,
                                                            name: '',
                                                            children: /*#__PURE__*/ React.createElement(VerifiedIcon, null),
                                                            columnSize: 0,
                                                            sx: {
                                                                p: 0,
                                                                mt: '5px'
                                                            },
                                                            color: 'primary',
                                                            setFieldProps: function (state) {
                                                                console.log("state", state);
                                                                return {
                                                                    type: FormItemTypes.Icon,
                                                                    sx: {
                                                                        display: customerPrimaryContactNo !== null && customerPrimaryContactNo !== void 0 && customerPrimaryContactNo.IsMobileVerified ? "inline-block" : 'none'
                                                                    }
                                                                };
                                                            }
                                                        }]
                                                }]
                                        } : null, isOpen ? {
                                            type: FormItemTypes.Box,
                                            label: '',
                                            name: '',
                                            value: null,
                                            columnSize: 12,
                                            margin: 0,
                                            sx: {
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: '8px',
                                                border: '1px solid ',
                                                paddingY: '16px',
                                                borderRadius: '12px',
                                                borderColor: "secondary.200"
                                            },
                                            elements: [{
                                                    type: FormItemTypes.Box,
                                                    name: '',
                                                    display: 'flex',
                                                    columnSize: 12,
                                                    paddingInline: '16px',
                                                    gap: '8px',
                                                    elements: [{
                                                            type: FormItemTypes.Avatar,
                                                            name: '',
                                                            columnSize: 0
                                                        }, {
                                                            type: FormItemTypes.Box,
                                                            name: '',
                                                            columnSize: 12,
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            gap: '4px',
                                                            elements: [{
                                                                    type: FormItemTypes.Box,
                                                                    name: '',
                                                                    display: 'flex',
                                                                    columnSize: 12,
                                                                    sx: {
                                                                        justifyContent: 'space-between'
                                                                    },
                                                                    height: '20px',
                                                                    elements: [{
                                                                            type: FormItemTypes.Typography,
                                                                            name: '',
                                                                            value: "".concat((_crud$ContractInvoice9 = (_crud$ContractInvoice10 = crud[ContractInvoiceKeys.CustomerDetailsKey]) === null || _crud$ContractInvoice10 === void 0 || (_crud$ContractInvoice10 = _crud$ContractInvoice10.data) === null || _crud$ContractInvoice10 === void 0 || (_crud$ContractInvoice10 = _crud$ContractInvoice10.Person) === null || _crud$ContractInvoice10 === void 0 ? void 0 : _crud$ContractInvoice10.GivenName) !== null && _crud$ContractInvoice9 !== void 0 ? _crud$ContractInvoice9 : '-', " ").concat((_crud$ContractInvoice11 = (_crud$ContractInvoice12 = crud[ContractInvoiceKeys === null || ContractInvoiceKeys === void 0 ? void 0 : ContractInvoiceKeys.CustomerDetailsKey]) === null || _crud$ContractInvoice12 === void 0 || (_crud$ContractInvoice12 = _crud$ContractInvoice12.data) === null || _crud$ContractInvoice12 === void 0 || (_crud$ContractInvoice12 = _crud$ContractInvoice12.Person) === null || _crud$ContractInvoice12 === void 0 ? void 0 : _crud$ContractInvoice12.FamilyName) !== null && _crud$ContractInvoice11 !== void 0 ? _crud$ContractInvoice11 : ''),
                                                                            columnSize: true,
                                                                            fontWeight: 'medium'
                                                                            // valueGetter(formValues, field) {
                                                                            //   return `${formValues?.CustomerName?.GivenName ?? '-'} ${formValues?.CustomerName?.FamilyName ?? '-'}`
                                                                            // },
                                                                        }, {
                                                                            type: FormItemTypes.Icon,
                                                                            name: '',
                                                                            children: /*#__PURE__*/ React.createElement(CustomerCardEditIcon, {
                                                                                color: "secondary"
                                                                            }),
                                                                            columnSize: 0,
                                                                            sx: {
                                                                                cursor: 'pointer',
                                                                                // p: 0,
                                                                                height: '20px',
                                                                                width: '20px'
                                                                            }
                                                                        }]
                                                                }, {
                                                                    type: FormItemTypes.Box,
                                                                    name: '',
                                                                    display: 'flex',
                                                                    columnSize: 12,
                                                                    gap: '8px',
                                                                    height: '18px',
                                                                    elements: [{
                                                                            type: FormItemTypes.Box,
                                                                            name: '',
                                                                            display: 'flex',
                                                                            columnSize: 0,
                                                                            gap: '4px',
                                                                            elements: [{
                                                                                    type: FormItemTypes.Typography,
                                                                                    name: '',
                                                                                    columnSize: 0,
                                                                                    value: (_customerPrimaryConta2 = customerPrimaryContactNo === null || customerPrimaryContactNo === void 0 ? void 0 : customerPrimaryContactNo.MobileNumber) !== null && _customerPrimaryConta2 !== void 0 ? _customerPrimaryConta2 : '-',
                                                                                    fontSize: 'sm',
                                                                                    fontWeight: 'normal',
                                                                                    color: "secondary.500"
                                                                                    // valueGetter(formValues, field) {
                                                                                    //   console.log("formValues", formValues)
                                                                                    //   return `${formValues?.CustomerNumber?.find((contact: any) => contact?.ContactType === "Primary")?.MobileNumber ?? '-'}`
                                                                                    // },
                                                                                }, {
                                                                                    type: FormItemTypes.Icon,
                                                                                    name: '',
                                                                                    children: /*#__PURE__*/ React.createElement(VerifiedIcon, null),
                                                                                    columnSize: 0,
                                                                                    sx: {
                                                                                        p: 0,
                                                                                        mt: '2px'
                                                                                    },
                                                                                    color: 'primary',
                                                                                    setFieldProps: function (state) {
                                                                                        return {
                                                                                            type: FormItemTypes.Icon,
                                                                                            sx: {
                                                                                                display: customerPrimaryContactNo !== null && customerPrimaryContactNo !== void 0 && customerPrimaryContactNo.IsMobileVerified ? undefined : 'none'
                                                                                            }
                                                                                        };
                                                                                    }
                                                                                }]
                                                                        }, {
                                                                            type: FormItemTypes.Divider,
                                                                            name: 'name',
                                                                            variant: 'fullWidth',
                                                                            orientation: 'vertical',
                                                                            columnSize: 0
                                                                        }, {
                                                                            type: FormItemTypes.Box,
                                                                            name: '',
                                                                            display: 'flex',
                                                                            columnSize: 0,
                                                                            gap: '4px',
                                                                            elements: [{
                                                                                    type: FormItemTypes.Typography,
                                                                                    name: '',
                                                                                    columnSize: 0,
                                                                                    value: (_customerSecondaryCon = customerSecondaryContactNo === null || customerSecondaryContactNo === void 0 ? void 0 : customerSecondaryContactNo.MobileNumber) !== null && _customerSecondaryCon !== void 0 ? _customerSecondaryCon : '-',
                                                                                    fontSize: 'sm',
                                                                                    fontWeight: 'normal',
                                                                                    color: "secondary.500"
                                                                                    // valueGetter(formValues, field) {
                                                                                    //   console.log("formValues", formValues)
                                                                                    //   return `${formValues?.CustomerNumber?.find((contact: any) => contact?.ContactType === "Secondary")?.MobileNumber ?? '-'}`
                                                                                    // },
                                                                                }
                                                                                // {
                                                                                //   type: FormItemTypes.Icon,
                                                                                //   name: '',
                                                                                //   children: <VerifiedIcon />,
                                                                                //   columnSize: 0,
                                                                                //   sx: {
                                                                                //      color: 'info.500',
                                                                                //     p: 0,
                                                                                //     mt: '2px'
                                                                                //   }
                                                                                // }
                                                                            ]
                                                                        }]
                                                                }]
                                                        }]
                                                }, {
                                                    type: FormItemTypes.Divider,
                                                    name: 'divider',
                                                    variant: 'fullWidth',
                                                    columnSize: 12
                                                }, {
                                                    type: FormItemTypes.Box,
                                                    name: '',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    columnSize: 12,
                                                    paddingInline: '16px',
                                                    gap: '8px',
                                                    elements: [{
                                                            type: FormItemTypes.Box,
                                                            name: '',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            columnSize: 12,
                                                            // paddingInline: '16px',
                                                            gap: '8px',
                                                            elements: [{
                                                                    type: FormItemTypes.Box,
                                                                    name: '',
                                                                    display: 'flex',
                                                                    columnSize: 12,
                                                                    gap: '8px',
                                                                    alignItems: 'center',
                                                                    elements: [{
                                                                            type: FormItemTypes.IconButton,
                                                                            name: '',
                                                                            children: /*#__PURE__*/ React.createElement(MailIconSVG, null),
                                                                            columnSize: 0,
                                                                            sx: {
                                                                                color: "secondary.500",
                                                                                paddingInline: 0
                                                                            }
                                                                        }, {
                                                                            type: FormItemTypes.Typography,
                                                                            name: '',
                                                                            columnSize: true,
                                                                            value: (_crud$ContractInvoice13 = crud[ContractInvoiceKeys.CustomerDetailsKey]) === null || _crud$ContractInvoice13 === void 0 || (_crud$ContractInvoice13 = _crud$ContractInvoice13.data) === null || _crud$ContractInvoice13 === void 0 || (_crud$ContractInvoice13 = _crud$ContractInvoice13.PersonContactPoint[1]) === null || _crud$ContractInvoice13 === void 0 ? void 0 : _crud$ContractInvoice13.Email,
                                                                            // color: ,
                                                                            fontSize: 'sm',
                                                                            fontWeight: 'normal'
                                                                        }]
                                                                }, {
                                                                    type: FormItemTypes.Box,
                                                                    name: '',
                                                                    display: 'flex',
                                                                    columnSize: 12,
                                                                    gap: '8px',
                                                                    alignItems: 'start',
                                                                    elements: [{
                                                                            type: FormItemTypes.IconButton,
                                                                            name: '',
                                                                            children: /*#__PURE__*/ React.createElement(LocationIcon, null),
                                                                            columnSize: 0,
                                                                            sx: {
                                                                                paddingInline: 0
                                                                            }
                                                                        }, {
                                                                            type: FormItemTypes.Typography,
                                                                            name: '',
                                                                            columnSize: true,
                                                                            // value: crud[ContractInvoiceKeys.CustomerDetailsKey]?.data?.Address[0]?.Address1 ?? '-',
                                                                            value: "".concat((_crud$ContractInvoice14 = (_crud$ContractInvoice15 = crud[ContractInvoiceKeys === null || ContractInvoiceKeys === void 0 ? void 0 : ContractInvoiceKeys.CustomerDetailsKey]) === null || _crud$ContractInvoice15 === void 0 || (_crud$ContractInvoice15 = _crud$ContractInvoice15.data) === null || _crud$ContractInvoice15 === void 0 || (_crud$ContractInvoice15 = _crud$ContractInvoice15.Address[0]) === null || _crud$ContractInvoice15 === void 0 ? void 0 : _crud$ContractInvoice15.Address1) !== null && _crud$ContractInvoice14 !== void 0 ? _crud$ContractInvoice14 : '-', " ").concat((_crud$ContractInvoice16 = (_crud$ContractInvoice17 = crud[ContractInvoiceKeys === null || ContractInvoiceKeys === void 0 ? void 0 : ContractInvoiceKeys.CustomerDetailsKey]) === null || _crud$ContractInvoice17 === void 0 || (_crud$ContractInvoice17 = _crud$ContractInvoice17.data) === null || _crud$ContractInvoice17 === void 0 || (_crud$ContractInvoice17 = _crud$ContractInvoice17.Address[0]) === null || _crud$ContractInvoice17 === void 0 ? void 0 : _crud$ContractInvoice17.Address2) !== null && _crud$ContractInvoice16 !== void 0 ? _crud$ContractInvoice16 : ' '),
                                                                            color: " secondary.500",
                                                                            fontSize: 'sm',
                                                                            fontWeight: 'normal'
                                                                        }]
                                                                }]
                                                        }]
                                                }]
                                        } : null]
                                }, {
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    xs: 12,
                                    sm: 6,
                                    md: 4,
                                    lg: 4,
                                    spacing: 0,
                                    elements: [{
                                            type: FormItemTypes.ContainerItem,
                                            name: 'BasicDetails',
                                            justifyContent: 'space-between',
                                            spacing: 0,
                                            alignItems: 'center',
                                            columnSize: 12,
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    children: 'Vehicle details',
                                                    fontSize: 'sm',
                                                    fontWeight: 'medium',
                                                    color: 'text.secondary',
                                                    columnSize: 0
                                                }, {
                                                    type: FormItemTypes.Button,
                                                    name: '',
                                                    children: 'Vehicle history',
                                                    size: 'small',
                                                    columnSize: 0,
                                                    onClick: function (e, formValue) {
                                                        var vehicleHistoryDrawer = dispatch(showSurface({
                                                            type: 'Drawer',
                                                            Component: VehicleHistory,
                                                            containerProps: {
                                                                PaperProps: {
                                                                    sx: {
                                                                        width: IS_MOBILE ? '100%' : '60%',
                                                                        borderRadius: IS_MOBILE ? '8px 8px 0 0' : null
                                                                    }
                                                                },
                                                                anchor: IS_MOBILE ? 'bottom' : 'right'
                                                            },
                                                            componentProps: {
                                                                selectedVinNo: formValue === null || formValue === void 0 ? void 0 : formValue.VinNo,
                                                                isRightDrawer: true
                                                            }
                                                        }));
                                                    }
                                                }]
                                        }, !isOpen ? {
                                            type: FormItemTypes.CardComponent,
                                            name: '',
                                            columnSize: 12,
                                            contentProps: {
                                                justifyContent: "space-between",
                                                spacing: 0
                                            },
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: 'RegistrationNo',
                                                    columnSize: 0,
                                                    // value: crud[ContractInvoiceKeys.InstallBaseListKey]?.data?.InstallBase[0]?.RegistrationNo ?? '-',
                                                    fontWeight: 'medium'
                                                }, {
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    columnSize: 0,
                                                    // value: `${crud[ContractInvoiceKeys.InstallBaseListKey]?.data?.InstallBase[0]?.ProductName} (${crud[ContractInvoiceKeys.InstallBaseListKey]?.data?.InstallBase[0]?.SKUCode ?? '-'})`,
                                                    fontSize: "sm",
                                                    color: 'text.secondary',
                                                    valueGetter: function (formValues, field) {
                                                        var productName = (formValues === null || formValues === void 0 ? void 0 : formValues.ProductName) || "-";
                                                        var skuCode = (formValues === null || formValues === void 0 ? void 0 : formValues.SKUCode) || "-";
                                                        return "".concat(productName, " ( ").concat(skuCode, " )");
                                                    }
                                                }]
                                        } : null, isOpen ? {
                                            type: FormItemTypes.CardComponent,
                                            name: '',
                                            columnSize: 12,
                                            contentProps: {
                                                spacing: 0,
                                                rowGap: 1
                                            },
                                            elements: [{
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    columnSize: 12,
                                                    spacing: 0,
                                                    elements: [{
                                                            type: FormItemTypes.Typography,
                                                            name: 'RegistrationNo',
                                                            columnSize: 12,
                                                            // value: crud[ContractInvoiceKeys.InstallBaseListKey]?.data?.InstallBase[0]?.RegistrationNo ?? '-',
                                                            fontWeight: 'medium'
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'ProductName',
                                                            columnSize: 12,
                                                            // value: `${crud[ContractInvoiceKeys.InstallBaseListKey]?.data?.InstallBase[0]?.ProductName} (${crud[ContractInvoiceKeys.InstallBaseListKey]?.data?.InstallBase[0]?.SKUCode ?? '-'})`,
                                                            fontSize: "sm",
                                                            color: 'text.secondary',
                                                            valueGetter: function (formValues, field) {
                                                                var productName = (formValues === null || formValues === void 0 ? void 0 : formValues.ProductName) || "-";
                                                                var skuCode = (formValues === null || formValues === void 0 ? void 0 : formValues.SKUCode) || "-";
                                                                return "".concat(productName, " ( ").concat(skuCode, " )");
                                                            }
                                                        }]
                                                }, {
                                                    type: FormItemTypes.CardComponent,
                                                    name: 'Vehicle details',
                                                    columnSize: 12,
                                                    sx: {
                                                        bgcolor: "secondary.50",
                                                        border: "none",
                                                        px: 1.5,
                                                        py: 1
                                                    },
                                                    contentProps: {
                                                        spacing: 0
                                                    },
                                                    elements: [{
                                                            type: FormItemTypes.Typography,
                                                            name: 'RegistrationNo',
                                                            label: 'Registration no:',
                                                            // value: crud[ContractInvoiceKeys.InstallBaseListKey]?.data?.InstallBase[0].RegistrationNo,
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'medium',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'medium',
                                                            fontSize: 'sm',
                                                            columnSize: 12
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'ProductName',
                                                            label: 'Model',
                                                            // value: crud[ContractInvoiceKeys.InstallBaseListKey]?.data?.InstallBase[0].ModelId,
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'medium',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'medium',
                                                            fontSize: 'sm',
                                                            columnSize: 12
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'EngineNo',
                                                            label: 'Engine no:',
                                                            // value: crud[ContractInvoiceKeys.InstallBaseListKey]?.data?.InstallBase[0].EngineNo,
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'medium',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'medium',
                                                            fontSize: 'sm',
                                                            columnSize: 12
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'VinNo',
                                                            label: 'Chassis no.:',
                                                            // value: crud[ContractInvoiceKeys.InstallBaseListKey]?.data?.InstallBase[0].VinNo,
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'medium',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'medium',
                                                            fontSize: 'sm',
                                                            columnSize: 12
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'SalesInvoiceDate',
                                                            label: 'Date of sale:',
                                                            // value: crud[ContractInvoiceKeys.InstallBaseListKey]?.data?.InstallBase[0].SalesInvoiceDate
                                                            //   ? dayjs(crud[ContractInvoiceKeys.InstallBaseListKey]?.data?.InstallBase[0].SalesInvoiceDate).format('DD-MM-YYYY')
                                                            //   : '-',
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'medium',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'medium',
                                                            fontSize: 'sm',
                                                            columnSize: 12,
                                                            valueGetter: function (formValues, field) {
                                                                return formValues !== null && formValues !== void 0 && formValues.SalesInvoiceDate ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues.SalesInvoiceDate).format("DD MMM, YYYY") : '-';
                                                            }
                                                        }]
                                                }]
                                        } : null]
                                }]
                        }]
                }]
        }, {
            type: FormItemTypes.CardComponent,
            name: '',
            columnSize: 12,
            label: 'Order details',
            setFieldProps: function (state) { return ({
                type: FormItemTypes.CardComponent,
                sx: {
                    display: state !== null && state !== void 0 && state.selectedVehicle ? undefined : 'none'
                }
            }); },
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: 'ApprovedById',
                    xs: 12,
                    sm: 6,
                    md: 3,
                    lg: 3,
                    label: 'Executive',
                    placeholder: ' Select executive',
                    getListData: executiveListAPI,
                    apiRequest: {
                        OrganizationId: UserOrganizationID
                    },
                    apiKey: ContractInvoiceKeys.ExecutiveListKey,
                    getOptionLabel: function (option) { return option.GivenName + " " + option.FamilyName; },
                    displayExpr: 'GivenName',
                    valueExpr: 'id'
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'PaymentModeId',
                    label: 'Payment Mode',
                    xs: 12,
                    sm: 6,
                    md: 3,
                    lg: 3,
                    placeholder: 'Select pay mode mode',
                    getListData: paymentModeListAPI,
                    apiKey: ContractInvoiceKeys.PaymentModeListKey,
                    getOptionLabel: function (option) { return option.Name; },
                    displayExpr: 'Name',
                    valueExpr: 'id',
                    setFormState: function (formValue, currValue) { return ({
                        PaymentModeName: currValue === null || currValue === void 0 ? void 0 : currValue.Name
                    }); }
                }]
        }, {
            type: FormItemTypes.CardComponent,
            name: '',
            label: 'Contract details',
            value: null,
            columnSize: 12,
            containerProps: {
                spacing: 0
            },
            setFieldProps: function (state) { return ({
                type: FormItemTypes.CardComponent,
                sx: {
                    display: state !== null && state !== void 0 && state.selectedVehicle ? undefined : 'none',
                    mb: IS_MOBILE ? '130px' : '100px'
                }
            }); },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    width: 'auto',
                    sx: {
                        overflowX: 'auto',
                        overflowY: 'visible',
                        flexWrap: 'nowrap',
                        width: '100%',
                        scrollbarWidth: 'none'
                    },
                    position: 'static',
                    elements: [{
                            type: FormItemTypes.CardComponent,
                            name: '',
                            columnSize: 0,
                            sx: {
                                padding: '6px',
                                bgcolor: 'secondary.100',
                                borderColor: 'secondary.200'
                            },
                            elements: [{
                                    type: FormItemTypes.Button,
                                    label: '',
                                    name: 'New',
                                    columnSize: 0,
                                    variant: 'text',
                                    color: 'secondary',
                                    size: 'small',
                                    setFormState: function (state, val, field) { return __awaiter(void 0, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            return [2 /*return*/, {
                                                    SelectedButton: field.name
                                                }];
                                        });
                                    }); },
                                    setFieldProps: function (state, value) {
                                        var _state$VehicleContrac3;
                                        var newcontractCount = (state === null || state === void 0 || (_state$VehicleContrac3 = state.VehicleContractDetails) === null || _state$VehicleContrac3 === void 0 || (_state$VehicleContrac3 = _state$VehicleContrac3.find(function (contract) { return (contract === null || contract === void 0 ? void 0 : contract.RegistrationNo) === (state === null || state === void 0 ? void 0 : state.selectedVehicle); })) === null || _state$VehicleContrac3 === void 0 || (_state$VehicleContrac3 = _state$VehicleContrac3.Items) === null || _state$VehicleContrac3 === void 0 ? void 0 : _state$VehicleContrac3.length) || 0;
                                        return {
                                            type: FormItemTypes.Button,
                                            variant: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'outlined' : 'text',
                                            color: 'secondary',
                                            sx: {
                                                fontWeight: 'strong',
                                                color: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'text.primary' : undefined,
                                                bgcolor: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'white' : "secondary.100"
                                            },
                                            children: ['New', /*#__PURE__*/ React.createElement(Chip, {
                                                    variant: "filled",
                                                    size: "small",
                                                    color: "secondary",
                                                    sx: {
                                                        fontWeight: 'medium',
                                                        color: 'text.primary',
                                                        display: newcontractCount ? 'inline-flex' : 'none'
                                                    },
                                                    label: newcontractCount
                                                })]
                                        };
                                    }
                                }, {
                                    type: FormItemTypes.Button,
                                    label: '',
                                    name: 'Active',
                                    columnSize: 0,
                                    variant: 'text',
                                    color: 'secondary',
                                    size: 'small',
                                    fullWidth: true,
                                    setFormState: function (state, val, field) { return __awaiter(void 0, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            return [2 /*return*/, {
                                                    SelectedButton: field.name
                                                }];
                                        });
                                    }); },
                                    setFieldProps: function (state, value) {
                                        var _state$ActiveContract, _state$ActiveContract2, _state$ActiveContract3, _state$ActiveContract4;
                                        return {
                                            type: FormItemTypes.Button,
                                            variant: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'outlined' : 'text',
                                            color: 'secondary',
                                            sx: {
                                                fontWeight: 'strong',
                                                color: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'text.primary' : undefined,
                                                bgcolor: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'white' : "secondary.100"
                                            },
                                            children: ['Active', /*#__PURE__*/ React.createElement(Chip, {
                                                    variant: "filled",
                                                    size: "small",
                                                    color: "secondary",
                                                    sx: {
                                                        fontWeight: 'medium',
                                                        color: 'text.primary',
                                                        display: ((_state$ActiveContract = state === null || state === void 0 || (_state$ActiveContract2 = state.ActiveContracts) === null || _state$ActiveContract2 === void 0 ? void 0 : _state$ActiveContract2.length) !== null && _state$ActiveContract !== void 0 ? _state$ActiveContract : 0) > 0 ? 'inline-flex' : 'none'
                                                    },
                                                    label: (_state$ActiveContract3 = state === null || state === void 0 || (_state$ActiveContract4 = state.ActiveContracts) === null || _state$ActiveContract4 === void 0 ? void 0 : _state$ActiveContract4.length) !== null && _state$ActiveContract3 !== void 0 ? _state$ActiveContract3 : 0
                                                })]
                                        };
                                    }
                                }]
                        }]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: 'data',
                    columnSize: 12,
                    spacing: 2.2,
                    setFieldProps: function (state) {
                        var _state$NewContracts;
                        return {
                            type: FormItemTypes.ContainerItem,
                            elements: state === null || state === void 0 || (_state$NewContracts = state.NewContracts) === null || _state$NewContracts === void 0 ? void 0 : _state$NewContracts.map(function (newContract, index) {
                                var _state$VehicleContrac4;
                                var matchedItem = state === null || state === void 0 || (_state$VehicleContrac4 = state.VehicleContractDetails) === null || _state$VehicleContrac4 === void 0 || (_state$VehicleContrac4 = _state$VehicleContrac4.find(function (contract) { return (contract === null || contract === void 0 ? void 0 : contract.RegistrationNo) === (state === null || state === void 0 ? void 0 : state.selectedVehicle); })) === null || _state$VehicleContrac4 === void 0 || (_state$VehicleContrac4 = _state$VehicleContrac4.Items) === null || _state$VehicleContrac4 === void 0 ? void 0 : _state$VehicleContrac4.find(function (item) { return (item === null || item === void 0 ? void 0 : item.ChildId) === (newContract === null || newContract === void 0 ? void 0 : newContract.id); });
                                var isAdded = !!matchedItem;
                                return {
                                    type: FormItemTypes.Box,
                                    name: '',
                                    xs: 12,
                                    sm: 6,
                                    md: 3,
                                    lg: 3,
                                    border: '1px solid',
                                    borderRadius: '12px',
                                    sx: {
                                        position: 'relative'
                                    },
                                    setFieldProps: function (state) { return ({
                                        type: FormItemTypes.Box,
                                        borderColor: isAdded ? 'primary.200' : "secondary.200"
                                    }); },
                                    elements: [{
                                            type: FormItemTypes.Icon,
                                            name: '',
                                            children: /*#__PURE__*/ React.createElement(CheckSVGIcon, {
                                                height: 24,
                                                width: 24,
                                                color: "currentColor"
                                            }),
                                            columnSize: 12,
                                            color: 'primary',
                                            sx: {
                                                display: 'flex',
                                                justifyContent: 'end',
                                                position: 'absolute',
                                                right: -10,
                                                top: -10
                                            },
                                            setFieldProps: function (state) { return ({
                                                type: FormItemTypes.Icon,
                                                sx: {
                                                    display: isAdded ? 'flex' : 'none',
                                                    justifyContent: 'end',
                                                    position: 'absolute',
                                                    right: -10,
                                                    top: -10
                                                }
                                            }); }
                                        }, {
                                            type: FormItemTypes.ContainerItem,
                                            name: '',
                                            columnSize: 12,
                                            spacing: 0,
                                            padding: '16px',
                                            gap: '12px',
                                            elements: [{
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    spacing: 0,
                                                    columnSize: 12,
                                                    justifyContent: 'space-between',
                                                    elements: [{
                                                            type: FormItemTypes.Typography,
                                                            name: 'Code',
                                                            value: newContract === null || newContract === void 0 ? void 0 : newContract.ChildCode,
                                                            columnSize: 0,
                                                            fontSize: 'sm',
                                                            fontWeight: 'medium',
                                                            color: 'secondary.600'
                                                        }, {
                                                            type: FormItemTypes.Chip,
                                                            name: '',
                                                            label: 'New',
                                                            size: 'small',
                                                            color: 'primary',
                                                            columnSize: 0,
                                                            sx: {
                                                                borderRadius: '6px'
                                                            }
                                                        }]
                                                }, {
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    value: newContract === null || newContract === void 0 ? void 0 : newContract.ChildName,
                                                    columnSize: 12,
                                                    fontSize: 'lg',
                                                    fontWeight: 'medium'
                                                }]
                                        }, {
                                            type: FormItemTypes.ContainerItem,
                                            name: '',
                                            columnSize: 12,
                                            spacing: 0,
                                            padding: '12px 16px 16px 16px',
                                            borderRadius: '0 0 12px 12px',
                                            gap: '20px',
                                            bgcolor: 'info.50',
                                            justifyContent: 'space-between',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            elements: [{
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    columnSize: 4,
                                                    spacing: 0,
                                                    direction: 'column',
                                                    elements: [{
                                                            type: FormItemTypes.Typography,
                                                            name: '',
                                                            value: "\u20B9 ".concat(newContract === null || newContract === void 0 ? void 0 : newContract.ContractPrice),
                                                            fontSize: 'lg',
                                                            fontWeight: 'strong',
                                                            columnSize: 0
                                                        }
                                                        // {
                                                        //   type: FormItemTypes.Typography,
                                                        //   name: '',
                                                        //   children: 'Inc. of taxes',
                                                        //   fontSize: 'sm',
                                                        //   fontWeight: 'medium',
                                                        //   columnSize: 0,
                                                        //   color: 'secondary.600'
                                                        // },
                                                    ]
                                                }, {
                                                    type: FormItemTypes.Button,
                                                    name: '',
                                                    variant: 'contained',
                                                    children: 'Add',
                                                    size: 'small',
                                                    startIcon: /*#__PURE__*/ React.createElement(PlusHeaderIcon, null),
                                                    columnSize: 0,
                                                    setFormState: function (formValues, currValue) { return __awaiter(void 0, void 0, void 0, function () {
                                                        var res, _formValues$VehicleCo, updatedContracts, updatedVehicleContractDetails, previousGrandTotal, newTotalAmount, updatedGrandTotal;
                                                        return __generator(this, function (_a) {
                                                            switch (_a.label) {
                                                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                                                        type: 'Drawer',
                                                                        Component: ContractDetailsDrawer,
                                                                        componentProps: {
                                                                            data: newContract
                                                                        },
                                                                        containerProps: {
                                                                            PaperProps: {
                                                                                sx: {
                                                                                    width: {
                                                                                        xs: '100%',
                                                                                        sm: '350px'
                                                                                    }
                                                                                }
                                                                            },
                                                                            anchor: IS_MOBILE ? 'bottom' : 'right'
                                                                        }
                                                                    }))];
                                                                case 1:
                                                                    res = _a.sent();
                                                                    if (res !== null && res !== void 0 && res.payload) {
                                                                        updatedContracts = __spreadArray(__spreadArray([], ((formValues === null || formValues === void 0 ? void 0 : formValues.SelectedContracts) || []), true), [_objectSpread(_objectSpread({}, res === null || res === void 0 ? void 0 : res.payload), {}, {
                                                                                isSelected: true
                                                                            })], false);
                                                                        updatedVehicleContractDetails = formValues === null || formValues === void 0 || (_formValues$VehicleCo = formValues.VehicleContractDetails) === null || _formValues$VehicleCo === void 0 ? void 0 : _formValues$VehicleCo.map(function (contract) {
                                                                            if ((contract === null || contract === void 0 ? void 0 : contract.RegistrationNo) === (formValues === null || formValues === void 0 ? void 0 : formValues.selectedVehicle)) {
                                                                                return _objectSpread(_objectSpread({}, contract), {}, {
                                                                                    Items: contract.Items ? __spreadArray(__spreadArray([], contract.Items, true), [res === null || res === void 0 ? void 0 : res.payload], false) : [res === null || res === void 0 ? void 0 : res.payload]
                                                                                });
                                                                            }
                                                                            return contract;
                                                                        });
                                                                        previousGrandTotal = parseFloat(formValues === null || formValues === void 0 ? void 0 : formValues.GrandTotal) || 0;
                                                                        newTotalAmount = parseFloat(newContract === null || newContract === void 0 ? void 0 : newContract.TotalAmount) || 0;
                                                                        updatedGrandTotal = (previousGrandTotal + newTotalAmount).toFixed(2);
                                                                        return [2 /*return*/, {
                                                                                // NewContracts: updatedNewContracts,
                                                                                // VehicleContractDetails: updatedVehicleContractDetails
                                                                                SelectedContracts: updatedContracts,
                                                                                GrandTotal: updatedGrandTotal,
                                                                                VehicleContractDetails: updatedVehicleContractDetails
                                                                            }];
                                                                    }
                                                                    return [2 /*return*/, {}];
                                                            }
                                                        });
                                                    }); },
                                                    setFieldProps: function (state) { return ({
                                                        type: FormItemTypes.Button,
                                                        sx: {
                                                            display: isAdded ? 'none' : undefined
                                                        }
                                                    }); }
                                                }, {
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    columnSize: 6,
                                                    spacing: 0,
                                                    flexDirection: 'row',
                                                    justifyContent: 'end',
                                                    gap: '16px',
                                                    setFieldProps: function (state) { return ({
                                                        type: FormItemTypes.ContainerItem,
                                                        sx: {
                                                            display: isAdded ? undefined : 'none'
                                                        }
                                                    }); },
                                                    elements: [{
                                                            type: FormItemTypes.Button,
                                                            name: '',
                                                            children: /*#__PURE__*/ React.createElement(CustomerCardEditIcon, null),
                                                            columnSize: 0,
                                                            color: 'secondary',
                                                            variant: 'outlined',
                                                            sx: {
                                                                padding: '8px'
                                                            },
                                                            setFormState: function (formValues) { return __awaiter(void 0, void 0, void 0, function () {
                                                                var res, _formValues$NewContra, _formValues$VehicleCo2, updatedNewContracts, updatedVehicleContractDetails;
                                                                return __generator(this, function (_a) {
                                                                    switch (_a.label) {
                                                                        case 0: return [4 /*yield*/, dispatch(showSurface({
                                                                                type: 'Drawer',
                                                                                Component: ContractDetailsDrawer,
                                                                                componentProps: {
                                                                                    data: matchedItem
                                                                                },
                                                                                containerProps: {
                                                                                    PaperProps: {
                                                                                        sx: {
                                                                                            width: {
                                                                                                xs: '100%',
                                                                                                sm: '350px'
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    anchor: IS_MOBILE ? 'bottom' : 'right'
                                                                                }
                                                                            }))];
                                                                        case 1:
                                                                            res = _a.sent();
                                                                            if (res !== null && res !== void 0 && res.payload) {
                                                                                updatedNewContracts = formValues === null || formValues === void 0 || (_formValues$NewContra = formValues.NewContracts) === null || _formValues$NewContra === void 0 ? void 0 : _formValues$NewContra.map(function (contract) { return contract.id === newContract.id ? _objectSpread(_objectSpread({}, contract), res.payload) : contract; });
                                                                                updatedVehicleContractDetails = formValues === null || formValues === void 0 || (_formValues$VehicleCo2 = formValues.VehicleContractDetails) === null || _formValues$VehicleCo2 === void 0 ? void 0 : _formValues$VehicleCo2.map(function (contract) {
                                                                                    if ((contract === null || contract === void 0 ? void 0 : contract.RegistrationNo) === (formValues === null || formValues === void 0 ? void 0 : formValues.selectedVehicle)) {
                                                                                        var _contract$Items;
                                                                                        return _objectSpread(_objectSpread({}, contract), {}, {
                                                                                            Items: ((_contract$Items = contract.Items) === null || _contract$Items === void 0 ? void 0 : _contract$Items.map(function (item) { return item.id === newContract.id ? _objectSpread(_objectSpread({}, item), res.payload) : item; })) || []
                                                                                        });
                                                                                    }
                                                                                    return contract;
                                                                                });
                                                                                return [2 /*return*/, {
                                                                                        NewContracts: updatedNewContracts,
                                                                                        VehicleContractDetails: updatedVehicleContractDetails
                                                                                    }];
                                                                            }
                                                                            return [2 /*return*/, {}];
                                                                    }
                                                                });
                                                            }); }
                                                        }, {
                                                            type: FormItemTypes.Button,
                                                            name: '',
                                                            children: /*#__PURE__*/ React.createElement(CloseIcon, {
                                                                height: '20px',
                                                                width: '20px'
                                                            }),
                                                            columnSize: 0,
                                                            color: 'primary',
                                                            variant: 'outlined',
                                                            sx: {
                                                                padding: '8px'
                                                            },
                                                            setFormState: function (formValues) { return __awaiter(void 0, void 0, void 0, function () {
                                                                var _formValues$VehicleCo3, updatedVehicleContractDetails, previousGrandTotal, newTotalAmount, updatedGrandTotal;
                                                                return __generator(this, function (_a) {
                                                                    updatedVehicleContractDetails = formValues === null || formValues === void 0 || (_formValues$VehicleCo3 = formValues.VehicleContractDetails) === null || _formValues$VehicleCo3 === void 0 ? void 0 : _formValues$VehicleCo3.map(function (contract) {
                                                                        if ((contract === null || contract === void 0 ? void 0 : contract.RegistrationNo) === (formValues === null || formValues === void 0 ? void 0 : formValues.selectedVehicle)) {
                                                                            var _contract$Items2;
                                                                            return _objectSpread(_objectSpread({}, contract), {}, {
                                                                                Items: (contract === null || contract === void 0 || (_contract$Items2 = contract.Items) === null || _contract$Items2 === void 0 ? void 0 : _contract$Items2.filter(function (item) { return (item === null || item === void 0 ? void 0 : item.ChildId) !== (newContract === null || newContract === void 0 ? void 0 : newContract.id); })) || []
                                                                            });
                                                                        }
                                                                        return contract;
                                                                    });
                                                                    previousGrandTotal = parseFloat(formValues === null || formValues === void 0 ? void 0 : formValues.GrandTotal) || 0;
                                                                    newTotalAmount = parseFloat(newContract === null || newContract === void 0 ? void 0 : newContract.TotalAmount) || 0;
                                                                    updatedGrandTotal = (previousGrandTotal - newTotalAmount).toFixed(2);
                                                                    return [2 /*return*/, {
                                                                            // SelectedContracts: updatedContracts,
                                                                            GrandTotal: updatedGrandTotal,
                                                                            VehicleContractDetails: updatedVehicleContractDetails
                                                                        }];
                                                                });
                                                            }); }
                                                        }]
                                                }]
                                        }]
                                };
                            }),
                            sx: {
                                display: (state === null || state === void 0 ? void 0 : state.SelectedButton) === 'New' ? undefined : 'none'
                            }
                        };
                    }
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: 'activeContracts',
                    columnSize: 12,
                    spacing: 2.2,
                    // gap: '20px',
                    setFieldProps: function (state) {
                        var _state$ActiveContract5;
                        return {
                            type: FormItemTypes.ContainerItem,
                            sx: {
                                display: (state === null || state === void 0 ? void 0 : state.SelectedButton) === 'Active' ? undefined : 'none'
                            },
                            elements: state === null || state === void 0 || (_state$ActiveContract5 = state.ActiveContracts) === null || _state$ActiveContract5 === void 0 ? void 0 : _state$ActiveContract5.map(function (ActiveContract, index) {
                                var _state$VehicleContrac5, _ActiveContract$Renew, _ActiveContract$Effec, _ActiveContract$Effec2;
                                var isAdded = (state === null || state === void 0 || (_state$VehicleContrac5 = state.VehicleContractDetails) === null || _state$VehicleContrac5 === void 0 || (_state$VehicleContrac5 = _state$VehicleContrac5.find(function (contract) { return (contract === null || contract === void 0 ? void 0 : contract.RegistrationNo) === (state === null || state === void 0 ? void 0 : state.selectedVehicle); })) === null || _state$VehicleContrac5 === void 0 || (_state$VehicleContrac5 = _state$VehicleContrac5.Items) === null || _state$VehicleContrac5 === void 0 ? void 0 : _state$VehicleContrac5.some(function (item) { return (item === null || item === void 0 ? void 0 : item.id) === (ActiveContract === null || ActiveContract === void 0 ? void 0 : ActiveContract.id); })) || false;
                                var effectiveTo = dayjs(ActiveContract === null || ActiveContract === void 0 ? void 0 : ActiveContract.EffectiveTo);
                                var today = dayjs();
                                var daysLeft = effectiveTo.diff(today, 'day');
                                var renewableWindow = parseInt((_ActiveContract$Renew = ActiveContract === null || ActiveContract === void 0 ? void 0 : ActiveContract.RenewableWindow) !== null && _ActiveContract$Renew !== void 0 ? _ActiveContract$Renew : "0", 10);
                                return {
                                    type: FormItemTypes.Box,
                                    name: '',
                                    xs: 12,
                                    sm: 6,
                                    md: 3,
                                    lg: 3,
                                    border: '1px solid',
                                    borderRadius: '12px',
                                    sx: {
                                        position: 'relative'
                                    },
                                    setFieldProps: function (state) { return ({
                                        type: FormItemTypes.Box,
                                        borderColor: isAdded ? 'primary.200' : "secondary.200"
                                    }); },
                                    elements: [{
                                            type: FormItemTypes.Icon,
                                            name: '',
                                            children: /*#__PURE__*/ React.createElement(CheckSVGIcon, {
                                                height: 24,
                                                width: 24,
                                                color: "currentColor"
                                            }),
                                            columnSize: 12,
                                            color: 'primary',
                                            sx: {
                                                display: 'flex',
                                                justifyContent: 'end',
                                                position: 'absolute',
                                                right: -10,
                                                top: -10
                                            },
                                            setFieldProps: function (state) { return ({
                                                type: FormItemTypes.Icon,
                                                sx: {
                                                    display: isAdded ? 'flex' : 'none',
                                                    justifyContent: 'end',
                                                    position: 'absolute',
                                                    right: -10,
                                                    top: -10
                                                }
                                            }); }
                                        }, {
                                            type: FormItemTypes.ContainerItem,
                                            name: '',
                                            columnSize: 12,
                                            spacing: 0,
                                            padding: '16px',
                                            gap: '16px',
                                            elements: [{
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    columnSize: 12,
                                                    spacing: 0,
                                                    elements: [{
                                                            type: FormItemTypes.ContainerItem,
                                                            name: '',
                                                            spacing: 0,
                                                            columnSize: 12,
                                                            justifyContent: 'space-between',
                                                            elements: [{
                                                                    type: FormItemTypes.Typography,
                                                                    name: '',
                                                                    value: "#".concat(ActiveContract === null || ActiveContract === void 0 ? void 0 : ActiveContract.ChildCode),
                                                                    columnSize: 0,
                                                                    fontSize: 'sm',
                                                                    fontWeight: 'medium',
                                                                    color: 'secondary.600'
                                                                }, {
                                                                    type: FormItemTypes.Chip,
                                                                    name: '',
                                                                    label: 'Active',
                                                                    size: 'small',
                                                                    color: 'primary',
                                                                    columnSize: 0,
                                                                    sx: {
                                                                        borderRadius: '6px'
                                                                    }
                                                                }]
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: '',
                                                            value: ActiveContract === null || ActiveContract === void 0 ? void 0 : ActiveContract.ChildName,
                                                            columnSize: 12,
                                                            fontSize: 'lg',
                                                            fontWeight: 'medium'
                                                        }]
                                                }, {
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    columnSize: 12,
                                                    spacing: 0,
                                                    bgcolor: 'background.secondary',
                                                    borderRadius: '8px',
                                                    padding: '12px',
                                                    gap: '8px',
                                                    elements: [{
                                                            type: FormItemTypes.Typography,
                                                            name: '',
                                                            label: 'Effective from:',
                                                            value: dayjs((_ActiveContract$Effec = ActiveContract === null || ActiveContract === void 0 ? void 0 : ActiveContract.EffectiveFrom) !== null && _ActiveContract$Effec !== void 0 ? _ActiveContract$Effec : '').format('DD MMM, YYYY'),
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'medium',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'medium',
                                                            fontSize: 'sm',
                                                            columnSize: 12
                                                        }, {
                                                            type: FormItemTypes.ContainerItem,
                                                            name: '',
                                                            columnSize: 12,
                                                            spacing: 0,
                                                            elements: [{
                                                                    type: FormItemTypes.Typography,
                                                                    name: 'sdas',
                                                                    label: 'Effective till:',
                                                                    value: dayjs((_ActiveContract$Effec2 = ActiveContract === null || ActiveContract === void 0 ? void 0 : ActiveContract.EffectiveTo) !== null && _ActiveContract$Effec2 !== void 0 ? _ActiveContract$Effec2 : '').format('DD MMM, YYYY'),
                                                                    containerProps: {
                                                                        display: 'inline-flex',
                                                                        justifyContent: 'space-between',
                                                                        alignItems: 'baseline',
                                                                        gap: 1
                                                                    },
                                                                    labelTypographyProps: {
                                                                        mb: 0,
                                                                        noWrap: true,
                                                                        fontWeight: 'medium',
                                                                        fontSize: 'sm'
                                                                    },
                                                                    fontWeight: 'medium',
                                                                    fontSize: 'sm',
                                                                    columnSize: 12
                                                                }, {
                                                                    type: FormItemTypes.Typography,
                                                                    name: '',
                                                                    value: daysLeft > 0 ? "Expiring in ".concat(daysLeft, " days") : "Expired ".concat(Math.abs(daysLeft), " days ago"),
                                                                    color: 'error.500',
                                                                    fontSize: 'sm',
                                                                    textAlign: 'end',
                                                                    fontWeight: 'medium',
                                                                    columnSize: 12,
                                                                    sx: {
                                                                        display: daysLeft > 0 && daysLeft <= renewableWindow ? undefined : 'none'
                                                                    }
                                                                }]
                                                        }]
                                                }]
                                        }, {
                                            type: FormItemTypes.ContainerItem,
                                            name: '',
                                            columnSize: 12,
                                            spacing: 0,
                                            padding: '12px 16px 16px 16px',
                                            borderRadius: '0 0 12px 12px',
                                            gap: '20px',
                                            bgcolor: 'info.50',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            elements: [{
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    columnSize: 6,
                                                    spacing: 0,
                                                    direction: 'column',
                                                    elements: [{
                                                            type: FormItemTypes.Typography,
                                                            name: '',
                                                            value: "\u20B9 ".concat(ActiveContract === null || ActiveContract === void 0 ? void 0 : ActiveContract.Price),
                                                            fontSize: 'lg',
                                                            fontWeight: 'strong',
                                                            columnSize: 0
                                                        }
                                                        // {
                                                        //   type: FormItemTypes.Typography,
                                                        //   name: '',
                                                        //   children: 'Inc. of taxes',
                                                        //   fontSize: 'sm',
                                                        //   fontWeight: 'medium',
                                                        //   columnSize: 0,
                                                        //   color: 'secondary.600'
                                                        // },
                                                    ]
                                                }, {
                                                    type: FormItemTypes.Button,
                                                    name: '',
                                                    variant: 'contained',
                                                    children: 'Renew',
                                                    size: 'small',
                                                    columnSize: 0,
                                                    setFieldProps: function (state) { return ({
                                                        type: FormItemTypes.Button,
                                                        sx: {
                                                            display: isAdded ? 'none' : undefined
                                                        }
                                                    }); },
                                                    setFormState: function (formValues, currValue) { return __awaiter(void 0, void 0, void 0, function () {
                                                        var _formValues$VehicleCo4, updatedContracts, updatedVehicleContractDetails;
                                                        return __generator(this, function (_a) {
                                                            updatedContracts = __spreadArray(__spreadArray([], ((formValues === null || formValues === void 0 ? void 0 : formValues.SelectedContracts) || []), true), [_objectSpread(_objectSpread({}, ActiveContract), {}, {
                                                                    isSelected: true
                                                                })], false);
                                                            updatedVehicleContractDetails = formValues === null || formValues === void 0 || (_formValues$VehicleCo4 = formValues.VehicleContractDetails) === null || _formValues$VehicleCo4 === void 0 ? void 0 : _formValues$VehicleCo4.map(function (contract) {
                                                                if ((contract === null || contract === void 0 ? void 0 : contract.RegistrationNo) === (formValues === null || formValues === void 0 ? void 0 : formValues.selectedVehicle)) {
                                                                    return _objectSpread(_objectSpread({}, contract), {}, {
                                                                        Items: contract.Items ? __spreadArray(__spreadArray([], contract.Items, true), [ActiveContract], false) : [ActiveContract]
                                                                    });
                                                                }
                                                                return contract;
                                                            });
                                                            return [2 /*return*/, {
                                                                    SelectedContracts: updatedContracts,
                                                                    VehicleContractDetails: updatedVehicleContractDetails
                                                                }];
                                                        });
                                                    }); }
                                                }, {
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    columnSize: 4.2,
                                                    spacing: 0,
                                                    flexDirection: 'row',
                                                    justifyContent: 'end',
                                                    gap: '16px',
                                                    setFieldProps: function (state) { return ({
                                                        type: FormItemTypes.ContainerItem,
                                                        sx: {
                                                            display: isAdded ? undefined : 'none'
                                                        }
                                                    }); },
                                                    elements: [{
                                                            type: FormItemTypes.Button,
                                                            name: '',
                                                            children: /*#__PURE__*/ React.createElement(CloseIcon, {
                                                                height: '20px',
                                                                width: '20px'
                                                            }),
                                                            columnSize: 0,
                                                            color: 'primary',
                                                            variant: 'outlined',
                                                            sx: {
                                                                padding: '8px'
                                                            },
                                                            setFormState: function (formValues) { return __awaiter(void 0, void 0, void 0, function () {
                                                                var _formValues$SelectedC, _formValues$VehicleCo5, updatedContracts, updatedVehicleContractDetails;
                                                                return __generator(this, function (_a) {
                                                                    updatedContracts = formValues === null || formValues === void 0 || (_formValues$SelectedC = formValues.SelectedContracts) === null || _formValues$SelectedC === void 0 ? void 0 : _formValues$SelectedC.filter(function (contract) { return contract.id !== ActiveContract.id; });
                                                                    updatedVehicleContractDetails = formValues === null || formValues === void 0 || (_formValues$VehicleCo5 = formValues.VehicleContractDetails) === null || _formValues$VehicleCo5 === void 0 ? void 0 : _formValues$VehicleCo5.map(function (contract) {
                                                                        if ((contract === null || contract === void 0 ? void 0 : contract.RegistrationNo) === (formValues === null || formValues === void 0 ? void 0 : formValues.selectedVehicle)) {
                                                                            var _contract$Items3;
                                                                            return _objectSpread(_objectSpread({}, contract), {}, {
                                                                                Items: (contract === null || contract === void 0 || (_contract$Items3 = contract.Items) === null || _contract$Items3 === void 0 ? void 0 : _contract$Items3.filter(function (item) { return item.id !== ActiveContract.id; })) || []
                                                                            });
                                                                        }
                                                                        return contract;
                                                                    });
                                                                    return [2 /*return*/, {
                                                                            SelectedContracts: updatedContracts,
                                                                            VehicleContractDetails: updatedVehicleContractDetails
                                                                        }];
                                                                });
                                                            }); }
                                                        }]
                                                }]
                                        }]
                                };
                            })
                        };
                    }
                }]
        }];
    var additionalInfo = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.CardComponent,
                    label: 'Additional info',
                    name: '',
                    md: 8,
                    elements: [{
                            type: FormItemTypes.TextInput,
                            name: 'Remarks',
                            label: 'Remark (0/500 character)',
                            multiline: true,
                            columnSize: 12,
                            minRows: IS_DESKTOP ? 6 : 3,
                            placeholder: 'Additional remarks',
                            sx: {
                                padding: '10px 0px'
                            },
                            setFieldProps: function (formValues, value) {
                                var _value$length;
                                return {
                                    type: this.type,
                                    label: "Remarks (".concat((_value$length = value === null || value === void 0 ? void 0 : value.length) !== null && _value$length !== void 0 ? _value$length : 0, "/500 )"),
                                    inputProps: {
                                        maxLength: 500
                                    }
                                };
                            }
                        }]
                }, {
                    type: FormItemTypes.CardComponent,
                    label: 'Customer Signature',
                    name: '',
                    // sx:{padding:'20px'},
                    md: 4,
                    elements: [{
                            type: FormItemTypes.Custom,
                            name: 'Signature',
                            label: 'Signature area',
                            columnSize: 12,
                            element: function (_ref2) {
                                var value = _ref2.value, _a = _ref2.name, name = _a === void 0 ? 'Status' : _a;
                                return /*#__PURE__*/ React.createElement(Box, {
                                    border: "1px solid",
                                    borderColor: "secondary.200",
                                    borderRadius: 2
                                }, /*#__PURE__*/ React.createElement(SignatureIndex, {
                                    setCanvasImage: '',
                                    canvasImage: '',
                                    isDisabled: isDisabled,
                                    height: '116px'
                                }));
                            }
                        }]
                }]
        }];
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: 'header',
            columnSize: 12,
            spacing: 0,
            paddingInline: IS_MOBILE ? '16px' : '24px',
            pt: '16px',
            pb: "20px",
            position: 'relative',
            elements: [{
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    xs: 12,
                    sm: 6,
                    md: 6,
                    lg: 6,
                    alignItems: 'center',
                    gap: '16px',
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(LeftArrow, null),
                            sx: {
                                color: 'secondary.600'
                            },
                            columnSize: 0,
                            onClick: function () {
                                navigate('/contractSaleInvoice');
                            }
                        }, {
                            type: FormItemTypes.Box,
                            name: '',
                            display: 'flex',
                            columnSize: true,
                            alignItems: 'center',
                            sx: {
                                justifyContent: {
                                    xs: "space-between",
                                    sm: 'start'
                                }
                            },
                            gap: '12px',
                            elements: [{
                                    type: FormItemTypes.Box,
                                    name: '',
                                    display: 'flex',
                                    alignItems: 'center',
                                    columnSize: 0,
                                    gap: '12px',
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: 'contractSaleInvoice',
                                            value: 'New Contract Sale Invoice',
                                            fontWeight: 'strong',
                                            fontSize: IS_MOBILE ? 'lg' : 'xxl',
                                            columnSize: 0
                                        }]
                                }]
                        }]
                }]
        }, {
            type: FormItemTypes.Box,
            name: '',
            height: '68px',
            padding: '16px 24px',
            gap: '12px',
            bgcolor: 'secondary.100',
            borderTop: '1px solid ',
            borderBottom: '1px solid ',
            borderColor: 'secondary.200',
            columnSize: 12,
            justifyContent: id ? 'end' : 'space-between',
            display: 'flex',
            elements: [!id ? {
                    type: FormItemTypes.Stack,
                    name: 'actions',
                    direction: 'row',
                    alignItems: 'center',
                    columnGap: 0.5,
                    borderRadius: 2,
                    px: 1.25,
                    py: 0.5,
                    border: '1px solid',
                    borderColor: 'secondary.300',
                    bgcolor: 'white',
                    width: '100%',
                    maxWidth: 400,
                    elements: [{
                            type: FormItemTypes.SingleSelect,
                            name: 'Key',
                            value: searchType[0].id,
                            options: searchType,
                            displayExpr: 'label',
                            variant: 'standard',
                            disableUnderline: true,
                            sx: {
                                minWidth: 90
                            },
                            columnSize: 0,
                            setFormState: function () { return ({
                                Value: ''
                            }); }
                        }, {
                            type: FormItemTypes.TextInput,
                            name: 'Value',
                            columnSize: true,
                            variant: 'standard',
                            placeholder: 'Search by Reg No, VIN, Mobile..',
                            InputProps: {
                                disableUnderline: true
                            },
                            valueSetter: function (state, currValue, field) {
                                var _a;
                                return (_a = {},
                                    _a[field.name] = currValue === null || currValue === void 0 ? void 0 : currValue.trim(),
                                    _a);
                            },
                            setFormState: function (formValues, currValue, field) {
                                return {
                                    resultnotfound: false,
                                    success: false
                                };
                            },
                            setFieldProps: function (formValues, currValue, field) {
                                var maxLength;
                                switch (formValues === null || formValues === void 0 ? void 0 : formValues.Key) {
                                    case 'RegistrationNo':
                                        maxLength = 12;
                                        break;
                                    case 'Mobile':
                                        maxLength = 10;
                                        break;
                                    case 'VinNo':
                                        maxLength = 17;
                                        break;
                                    default:
                                        maxLength = undefined;
                                }
                                return {
                                    type: FormItemTypes.TextInput,
                                    maxLength: maxLength
                                };
                            }
                        }, {
                            type: FormItemTypes.IconButton,
                            name: 'searchButton',
                            columnSize: 0,
                            color: 'secondary',
                            disabled: isSearchLoading,
                            children: isSearchLoading ? /*#__PURE__*/ React.createElement(CircularProgress, {
                                size: 20
                            }) : /*#__PURE__*/ React.createElement(Search, {
                                color: "secondary"
                            }),
                            setFormState: handleClickSearch,
                            setFieldProps: function (formValues, currValue, field) {
                                var _formValues$Key, _formValues$Value, _formValues$Value2, _formValues$Value3, _formValues$Value4;
                                console.log('formValues', formValues);
                                var disabled = true;
                                if ((formValues === null || formValues === void 0 || (_formValues$Key = formValues.Key) === null || _formValues$Key === void 0 ? void 0 : _formValues$Key.toLowerCase()) === 'registrationno' && (formValues === null || formValues === void 0 || (_formValues$Value = formValues.Value) === null || _formValues$Value === void 0 ? void 0 : _formValues$Value.length) >= 4 && (formValues === null || formValues === void 0 || (_formValues$Value2 = formValues.Value) === null || _formValues$Value2 === void 0 ? void 0 : _formValues$Value2.length) <= 12) {
                                    disabled = false;
                                }
                                else if ((formValues === null || formValues === void 0 ? void 0 : formValues.Key) === 'VinNo' && (formValues === null || formValues === void 0 || (_formValues$Value3 = formValues.Value) === null || _formValues$Value3 === void 0 ? void 0 : _formValues$Value3.length) === 17) {
                                    disabled = false;
                                }
                                else if ((formValues === null || formValues === void 0 ? void 0 : formValues.Key) === 'Mobile' && (formValues === null || formValues === void 0 || (_formValues$Value4 = formValues.Value) === null || _formValues$Value4 === void 0 ? void 0 : _formValues$Value4.length) === 10) {
                                    disabled = false;
                                }
                                return {
                                    type: FormItemTypes.IconButton,
                                    disabled: disabled
                                };
                            }
                        }]
                } : null, IS_DESKTOP ? {
                    type: FormItemTypes.Box,
                    name: '',
                    justifyContent: 'end',
                    display: 'flex',
                    columnSize: 9,
                    gap: '12px',
                    elements: [{
                            type: FormItemTypes.Button,
                            name: '',
                            variant: 'text',
                            children: IS_DESKTOP ? 'Quick links' : '',
                            columnSize: 0,
                            sx: {
                                bgcolor: 'transparent',
                                fontWeight: 'medium'
                            },
                            startIcon: /*#__PURE__*/ React.createElement(LinkSvg, null)
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(Download, null),
                            columnSize: 0,
                            color: 'secondary',
                            variant: 'outlined',
                            sx: {
                                padding: '8px'
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement("img", {
                                src: ShareIcon,
                                alt: "",
                                loading: "lazy"
                            }),
                            columnSize: 0,
                            color: 'secondary',
                            variant: 'outlined',
                            sx: {
                                padding: '8px'
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(PrintIconSVG, null),
                            columnSize: 0,
                            color: 'secondary',
                            variant: 'outlined',
                            sx: {
                                padding: '8px'
                            }
                        }, {
                            type: FormItemTypes.Divider,
                            name: '',
                            variant: 'fullWidth',
                            orientation: 'vertical',
                            columnSize: 0
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            variant: 'text',
                            children: 'Discard',
                            columnSize: 0,
                            color: 'secondary',
                            onClick: function () { return clickOnDiscard(); }
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            variant: 'contained',
                            children: 'Save',
                            color: 'primary',
                            columnSize: 0,
                            setFieldProps: function (state) {
                                var _state$VehicleContrac6, _state$VehicleContrac7;
                                return {
                                    type: FormItemTypes.Button,
                                    disabled: !(state !== null && state !== void 0 && state.VehicleContractDetails && (state === null || state === void 0 || (_state$VehicleContrac6 = state.VehicleContractDetails) === null || _state$VehicleContrac6 === void 0 ? void 0 : _state$VehicleContrac6.length) > 0 && state !== null && state !== void 0 && (_state$VehicleContrac7 = state.VehicleContractDetails) !== null && _state$VehicleContrac7 !== void 0 && _state$VehicleContrac7.every(function (item) {
                                        var _item$Items;
                                        return Array.isArray(item.Items) && (item === null || item === void 0 || (_item$Items = item.Items) === null || _item$Items === void 0 ? void 0 : _item$Items.length) > 0;
                                    }))
                                };
                            },
                            setFormState: function (formValues) { return __awaiter(void 0, void 0, void 0, function () {
                                var attachmentReq, file, _data$payload, _data$payload2, data, _data$payload3, _uploadRes$payload, _uploadRes$payload2, uploadRes, _crud$ContractInvoice18, paymentRes, _formValues$Customer, _formValues$InstallBa2, _formValues$Customer2, _uploadRes$payload3, _upsertRes$payload, JSIRequest, upsertRes, _upsertRes$payload2, upsertSuccess, error_1;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!signature) return [3 /*break*/, 11];
                                            attachmentReq = {
                                                ParentId: "00000000-0000-0000-0000-000000000000",
                                                ImageAttachments: [{
                                                        MediaType: 1,
                                                        SystemName: 'InvoiceDocumentAttachment'
                                                    }]
                                            };
                                            return [4 /*yield*/, dataURLtoFile(signature, "sign.png")];
                                        case 1:
                                            file = _a.sent();
                                            _a.label = 2;
                                        case 2:
                                            _a.trys.push([2, 9, , 10]);
                                            return [4 /*yield*/, dispatch(createAPI({
                                                    key: JSIAttachmentAPIKeys.create,
                                                    url: JsiAttachmentCreateAPI,
                                                    request: attachmentReq
                                                }))];
                                        case 3:
                                            data = _a.sent();
                                            if (!(data !== null && data !== void 0 && (_data$payload = data.payload) !== null && _data$payload !== void 0 && (_data$payload = _data$payload.value) !== null && _data$payload !== void 0 && _data$payload.success && (data === null || data === void 0 || (_data$payload2 = data.payload) === null || _data$payload2 === void 0 || (_data$payload2 = _data$payload2.value) === null || _data$payload2 === void 0 ? void 0 : _data$payload2.statusCode) === 201)) return [3 /*break*/, 8];
                                            return [4 /*yield*/, dispatch(uploadAttachmentAPI({
                                                    key: JSIAttachmentAPIKeys.upload,
                                                    url: JsiAttachmentUploadAPI(data === null || data === void 0 || (_data$payload3 = data.payload) === null || _data$payload3 === void 0 || (_data$payload3 = _data$payload3.value) === null || _data$payload3 === void 0 || (_data$payload3 = _data$payload3.data[0]) === null || _data$payload3 === void 0 ? void 0 : _data$payload3.InvoiceDocumentAttachmentId),
                                                    request: {
                                                        systemname: "InvoiceDocumentAttachment",
                                                        data: file
                                                    }
                                                }))];
                                        case 4:
                                            uploadRes = _a.sent();
                                            if (!(uploadRes !== null && uploadRes !== void 0 && (_uploadRes$payload = uploadRes.payload) !== null && _uploadRes$payload !== void 0 && (_uploadRes$payload = _uploadRes$payload.value) !== null && _uploadRes$payload !== void 0 && _uploadRes$payload.success && (uploadRes === null || uploadRes === void 0 || (_uploadRes$payload2 = uploadRes.payload) === null || _uploadRes$payload2 === void 0 || (_uploadRes$payload2 = _uploadRes$payload2.value) === null || _uploadRes$payload2 === void 0 ? void 0 : _uploadRes$payload2.statusCode) === 200)) return [3 /*break*/, 8];
                                            return [4 /*yield*/, dispatch(showSurface({
                                                    type: 'Dialog',
                                                    Component: PaymentReceivePopup,
                                                    componentProps: {
                                                        data: formValues,
                                                        PaymentTypeId: (_crud$ContractInvoice18 = crud[ContractInvoiceKeys.PaymentModeListKey]) === null || _crud$ContractInvoice18 === void 0 ? void 0 : _crud$ContractInvoice18.data
                                                    }
                                                }))];
                                        case 5:
                                            paymentRes = _a.sent();
                                            if (!(paymentRes !== null && paymentRes !== void 0 && paymentRes.payload)) return [3 /*break*/, 8];
                                            JSIRequest = _objectSpread(_objectSpread({}, paymentRes === null || paymentRes === void 0 ? void 0 : paymentRes.payload), {}, {
                                                CustomerId: id ? formValues === null || formValues === void 0 ? void 0 : formValues.CustomerId : formValues === null || formValues === void 0 || (_formValues$Customer = formValues.Customer) === null || _formValues$Customer === void 0 ? void 0 : _formValues$Customer.CustomerId,
                                                ParentEntityId: formValues === null || formValues === void 0 || (_formValues$InstallBa2 = formValues.InstallBase) === null || _formValues$InstallBa2 === void 0 || (_formValues$InstallBa2 = _formValues$InstallBa2[0]) === null || _formValues$InstallBa2 === void 0 ? void 0 : _formValues$InstallBa2.SchemaId,
                                                SubTotal: parseFloat(formValues === null || formValues === void 0 ? void 0 : formValues.GrandTotal),
                                                TotalDiscount: 0,
                                                OtherCharges: 0,
                                                TotalTax: 0,
                                                GrandTotal: parseFloat(formValues === null || formValues === void 0 ? void 0 : formValues.GrandTotal),
                                                ApprovedById: formValues === null || formValues === void 0 ? void 0 : formValues.ApprovedById,
                                                ValidTillDateTime: formValues === null || formValues === void 0 ? void 0 : formValues.ValidTillDateTime,
                                                Remarks: formValues === null || formValues === void 0 ? void 0 : formValues.Remarks,
                                                OrganizationId: UserOrganizationID,
                                                ParentOrganizationId: ParentOrganizationID,
                                                PersonId: formValues === null || formValues === void 0 || (_formValues$Customer2 = formValues.Customer) === null || _formValues$Customer2 === void 0 ? void 0 : _formValues$Customer2.PersonId,
                                                PersonContactPointId: null,
                                                CGST_Amount: 0,
                                                CGST_Percentage: 0,
                                                SGST_UTGST_Amount: 0,
                                                SGST_UTGST_Percentage: 0,
                                                IGST_Amount: 0,
                                                IGST_Percentage: 0,
                                                SystemName: 'ServiceContract',
                                                VehicleContractDetails: formValues === null || formValues === void 0 ? void 0 : formValues.VehicleContractDetails,
                                                InvoicePayment: {
                                                    PaymentDate: dayjs(),
                                                    PaymentDueDate: formValues === null || formValues === void 0 ? void 0 : formValues.PaymentDueDate,
                                                    PaymentTermId: formValues === null || formValues === void 0 ? void 0 : formValues.PaymentTermId,
                                                    PaymentModeId: formValues === null || formValues === void 0 ? void 0 : formValues.PaymentModeId,
                                                    PaymentTypeId: formValues === null || formValues === void 0 ? void 0 : formValues.PaymentTypeId,
                                                    Remarks: ""
                                                },
                                                AccountPosting: [{
                                                        AccountId: "",
                                                        DebitAmount: "",
                                                        CreditAmount: ""
                                                    }],
                                                ImageAttachments: [{
                                                        AttachmentId: uploadRes === null || uploadRes === void 0 || (_uploadRes$payload3 = uploadRes.payload) === null || _uploadRes$payload3 === void 0 || (_uploadRes$payload3 = _uploadRes$payload3.value) === null || _uploadRes$payload3 === void 0 ? void 0 : _uploadRes$payload3.attachmentId
                                                    }]
                                            });
                                            return [4 /*yield*/, dispatch(createAPI({
                                                    key: ContractInvoiceKeys.ContractInvoiceUpsertKey,
                                                    url: UpsertNewContractURL,
                                                    request: JSIRequest
                                                }))];
                                        case 6:
                                            upsertRes = _a.sent();
                                            if (!(upsertRes !== null && upsertRes !== void 0 && (_upsertRes$payload = upsertRes.payload) !== null && _upsertRes$payload !== void 0 && (_upsertRes$payload = _upsertRes$payload.value) !== null && _upsertRes$payload !== void 0 && _upsertRes$payload.success)) return [3 /*break*/, 8];
                                            return [4 /*yield*/, dispatch(showSurface({
                                                    type: 'Dialog',
                                                    Component: InvoiceSavedPopup,
                                                    componentProps: {
                                                        data: formValues,
                                                        resData: upsertRes === null || upsertRes === void 0 || (_upsertRes$payload2 = upsertRes.payload) === null || _upsertRes$payload2 === void 0 || (_upsertRes$payload2 = _upsertRes$payload2.value) === null || _upsertRes$payload2 === void 0 ? void 0 : _upsertRes$payload2.data
                                                    }
                                                }))];
                                        case 7:
                                            upsertSuccess = _a.sent();
                                            if ((upsertSuccess === null || upsertSuccess === void 0 ? void 0 : upsertSuccess.payload) === 'goHome') {
                                                navigate('/contractSaleInvoice');
                                            }
                                            _a.label = 8;
                                        case 8: return [3 /*break*/, 10];
                                        case 9:
                                            error_1 = _a.sent();
                                            console.error("Error during attachment creation/upload:", error_1);
                                            return [3 /*break*/, 10];
                                        case 10: return [3 /*break*/, 12];
                                        case 11:
                                            dispatch(showNotification({
                                                isOpen: true,
                                                message: 'Signature is mandatory',
                                                type: "error"
                                            }));
                                            _a.label = 12;
                                        case 12: return [2 /*return*/];
                                    }
                                });
                            }); }
                        }]
                } : null]
        }, {
            type: FormItemTypes.Stack,
            name: '',
            columnSize: 12,
            height: '212px',
            width: "100%",
            justifyContent: 'center',
            alignItems: 'center',
            setFieldProps: function (state) { return ({
                type: FormItemTypes.ContainerItem,
                sx: {
                    display: state !== null && state !== void 0 && state.resultnotfound ? undefined : 'none'
                },
                elements: [{
                        type: FormItemTypes.Stack,
                        name: '',
                        width: '270px',
                        gap: '16px',
                        justifyContent: 'center',
                        alignItems: 'center',
                        elements: [{
                                type: FormItemTypes.Button,
                                name: '',
                                color: 'secondary',
                                variant: 'outlined',
                                children: /*#__PURE__*/ React.createElement(Search, {
                                    color: "secondary"
                                }),
                                columnSize: 0
                            }, {
                                type: FormItemTypes.Stack,
                                name: '',
                                columnSize: 12,
                                gap: '4px',
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: '',
                                        children: 'Result not found',
                                        fontSize: 'lg',
                                        fontWeight: 'strong',
                                        textAlign: 'center',
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: '',
                                        children: "Your search \u201C".concat(state === null || state === void 0 ? void 0 : state.Value, "\u201D did not match any ").concat(state === null || state === void 0 ? void 0 : state.Key, ". Please try again."),
                                        columnSize: 12,
                                        color: 'secondary.500',
                                        textAlign: 'center'
                                    }]
                            }]
                    }]
            }); }
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            position: 'relative',
            setFieldProps: function (state) { return ({
                type: FormItemTypes.ContainerItem,
                sx: {
                    display: state !== null && state !== void 0 && state.success || id ? undefined : 'none'
                }
            }); },
            elements: [{
                    type: FormItemTypes.Tabs,
                    name: 'Tabs',
                    columnSize: 12,
                    valueExpr: 'id',
                    displayExpr: 'Name',
                    panelGridProps: {
                        spacing: 2,
                        px: 3
                    },
                    tabs: [{
                            id: 'general',
                            Name: 'General',
                            elements: generalFields
                        }, {
                            id: "accountPosting",
                            Name: "Account Posting",
                            elements: accountPosting
                        }, {
                            id: 'additionalInfo',
                            Name: 'Additional info',
                            elements: additionalInfo
                        }]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    justifyContent: 'end',
                    padding: '20px 24px',
                    borderTop: '1px solid',
                    borderColor: 'secondary.200',
                    position: 'fixed',
                    right: 0,
                    bottom: IS_MOBILE ? 71 : 0,
                    zIndex: 10,
                    height: '84px',
                    bgcolor: 'secondary.50',
                    setFieldProps: function (state) { return ({
                        type: FormItemTypes.ContainerItem,
                        sx: {
                            display: state !== null && state !== void 0 && state.selectedVehicle ? undefined : 'none'
                        }
                    }); },
                    elements: [{
                            type: FormItemTypes.Button,
                            name: 'orderSummary',
                            variant: 'outlined',
                            fullWidth: true,
                            color: 'secondary',
                            sx: {
                                bgcolor: 'white'
                            },
                            xs: 12,
                            sm: 6,
                            md: 4,
                            lg: 4,
                            startIcon: /*#__PURE__*/ React.createElement(RightArrow, {
                                color: "text.secondary",
                                height: 20,
                                width: 20
                            }),
                            setFieldProps: function (state) { return ({
                                type: FormItemTypes.Button,
                                children: /*#__PURE__*/ React.createElement(Stack, {
                                    width: '100%',
                                    justifyContent: 'space-between',
                                    direction: 'row',
                                    color: 'secondary.900'
                                }, " ", /*#__PURE__*/ React.createElement(Typography, {
                                    fontWeight: 'strong'
                                }, "Total amount"), /*#__PURE__*/ React.createElement(Typography, {
                                    fontWeight: 'strong'
                                }, "\u20B9 ", Number(state === null || state === void 0 ? void 0 : state.GrandTotal) ? Number(state === null || state === void 0 ? void 0 : state.GrandTotal).toFixed(2) : 0..toFixed(2), " "))
                            }); },
                            setFormState: function (formValues, e) { return __awaiter(void 0, void 0, void 0, function () {
                                var _e$target, _e$target2, _rect$top, rect, res;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            rect = e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 || (_e$target = _e$target.closest('button')) === null || _e$target === void 0 ? void 0 : _e$target.getBoundingClientRect();
                                            return [4 /*yield*/, IS_MOBILE];
                                        case 1:
                                            res = (_a.sent()) ? dispatch(showSurface({
                                                type: 'Drawer',
                                                Component: InvoiceSummaryPopup,
                                                containerProps: {
                                                    anchor: 'bottom',
                                                    PaperProps: {
                                                        sx: {
                                                            borderRadius: '8px 8px 0 0'
                                                        }
                                                    }
                                                },
                                                componentProps: {
                                                    formValues: formValues
                                                }
                                            })) : dispatch(showSurface({
                                                type: 'Menu',
                                                Component: InvoiceSummaryPopup,
                                                componentProps: {
                                                    formValues: formValues
                                                },
                                                containerProps: {
                                                    anchorEl: e === null || e === void 0 || (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.closest('#orderSummary'),
                                                    anchorOrigin: {
                                                        vertical: 'top',
                                                        horizontal: 'right'
                                                    },
                                                    transformOrigin: {
                                                        vertical: 'top',
                                                        horizontal: 'right'
                                                    },
                                                    slotProps: {
                                                        paper: {
                                                            sx: {
                                                                bottom: "calc(100svh - ".concat(((_rect$top = rect === null || rect === void 0 ? void 0 : rect.top) !== null && _rect$top !== void 0 ? _rect$top : 0) - 10, "px)"),
                                                                top: 'unset !important'
                                                            }
                                                        }
                                                    }
                                                }
                                            }));
                                            return [2 /*return*/];
                                    }
                                });
                            }); }
                        }]
                }]
        }, IS_MOBILE ? {
            type: FormItemTypes.Box,
            name: '',
            display: 'flex',
            columnSize: 12,
            position: 'fixed',
            bottom: 0,
            right: 0,
            bgcolor: 'white',
            p: 2,
            width: '100%',
            justifyContent: 'space-between',
            sx: {
                borderTop: '1px solid ',
                borderColor: 'secondary.200',
                gap: '16px'
            },
            setFieldProps: function (state) { return ({
                type: FormItemTypes.ContainerItem,
                sx: {
                    display: state !== null && state !== void 0 && state.selectedVehicle ? undefined : 'none'
                },
                elements: [{
                        type: FormItemTypes.Button,
                        id: "createDocument",
                        name: '',
                        children: 'Discard ',
                        variant: 'text',
                        color: 'secondary',
                        columnSize: 0,
                        onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                            var res;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, dispatch(showSurface({
                                            type: 'Drawer',
                                            Component: DiscardInvoicePopup,
                                            containerProps: {
                                                PaperProps: {
                                                    sx: {
                                                        width: '100vw',
                                                        borderRadius: '8px 8px 0 0'
                                                    }
                                                },
                                                anchor: 'bottom'
                                            }
                                        }))];
                                    case 1:
                                        res = _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }
                    }, {
                        type: FormItemTypes.Button,
                        id: "createDocument",
                        name: '',
                        children: 'Save',
                        variant: 'contained',
                        color: 'primary',
                        columnSize: 0,
                        setFormState: function (formValues) { return __awaiter(void 0, void 0, void 0, function () {
                            var attachmentReq, file, _data$payload4, _data$payload5, data, _data$payload6, _uploadRes$payload4, _uploadRes$payload5, uploadRes, _crud$ContractInvoice19, paymentRes, _formValues$Customer3, _formValues$InstallBa3, _formValues$Customer4, _uploadRes$payload6, _upsertRes$payload3, JSIRequest, upsertRes, _upsertRes$payload4, upsertSuccess, error_2;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!signature) return [3 /*break*/, 11];
                                        attachmentReq = {
                                            ParentId: "00000000-0000-0000-0000-000000000000",
                                            ImageAttachments: [{
                                                    MediaType: 1,
                                                    SystemName: 'InvoiceDocumentAttachment'
                                                }]
                                        };
                                        return [4 /*yield*/, dataURLtoFile(signature, "sign.png")];
                                    case 1:
                                        file = _a.sent();
                                        _a.label = 2;
                                    case 2:
                                        _a.trys.push([2, 9, , 10]);
                                        return [4 /*yield*/, dispatch(createAPI({
                                                key: JSIAttachmentAPIKeys.create,
                                                url: JsiAttachmentCreateAPI,
                                                request: attachmentReq
                                            }))];
                                    case 3:
                                        data = _a.sent();
                                        if (!(data !== null && data !== void 0 && (_data$payload4 = data.payload) !== null && _data$payload4 !== void 0 && (_data$payload4 = _data$payload4.value) !== null && _data$payload4 !== void 0 && _data$payload4.success && (data === null || data === void 0 || (_data$payload5 = data.payload) === null || _data$payload5 === void 0 || (_data$payload5 = _data$payload5.value) === null || _data$payload5 === void 0 ? void 0 : _data$payload5.statusCode) === 201)) return [3 /*break*/, 8];
                                        return [4 /*yield*/, dispatch(uploadAttachmentAPI({
                                                key: JSIAttachmentAPIKeys.upload,
                                                url: JsiAttachmentUploadAPI(data === null || data === void 0 || (_data$payload6 = data.payload) === null || _data$payload6 === void 0 || (_data$payload6 = _data$payload6.value) === null || _data$payload6 === void 0 || (_data$payload6 = _data$payload6.data[0]) === null || _data$payload6 === void 0 ? void 0 : _data$payload6.InvoiceDocumentAttachmentId),
                                                request: {
                                                    systemname: "InvoiceDocumentAttachment",
                                                    data: file
                                                }
                                            }))];
                                    case 4:
                                        uploadRes = _a.sent();
                                        if (!(uploadRes !== null && uploadRes !== void 0 && (_uploadRes$payload4 = uploadRes.payload) !== null && _uploadRes$payload4 !== void 0 && (_uploadRes$payload4 = _uploadRes$payload4.value) !== null && _uploadRes$payload4 !== void 0 && _uploadRes$payload4.success && (uploadRes === null || uploadRes === void 0 || (_uploadRes$payload5 = uploadRes.payload) === null || _uploadRes$payload5 === void 0 || (_uploadRes$payload5 = _uploadRes$payload5.value) === null || _uploadRes$payload5 === void 0 ? void 0 : _uploadRes$payload5.statusCode) === 200)) return [3 /*break*/, 8];
                                        return [4 /*yield*/, dispatch(showSurface({
                                                type: 'Dialog',
                                                Component: PaymentReceivePopup,
                                                componentProps: {
                                                    data: formValues,
                                                    PaymentTypeId: (_crud$ContractInvoice19 = crud[ContractInvoiceKeys.PaymentModeListKey]) === null || _crud$ContractInvoice19 === void 0 ? void 0 : _crud$ContractInvoice19.data
                                                }
                                            }))];
                                    case 5:
                                        paymentRes = _a.sent();
                                        if (!(paymentRes !== null && paymentRes !== void 0 && paymentRes.payload)) return [3 /*break*/, 8];
                                        JSIRequest = _objectSpread(_objectSpread({}, paymentRes === null || paymentRes === void 0 ? void 0 : paymentRes.payload), {}, {
                                            CustomerId: id ? formValues === null || formValues === void 0 ? void 0 : formValues.CustomerId : formValues === null || formValues === void 0 || (_formValues$Customer3 = formValues.Customer) === null || _formValues$Customer3 === void 0 ? void 0 : _formValues$Customer3.CustomerId,
                                            ParentEntityId: formValues === null || formValues === void 0 || (_formValues$InstallBa3 = formValues.InstallBase) === null || _formValues$InstallBa3 === void 0 || (_formValues$InstallBa3 = _formValues$InstallBa3[0]) === null || _formValues$InstallBa3 === void 0 ? void 0 : _formValues$InstallBa3.SchemaId,
                                            SubTotal: parseFloat(formValues === null || formValues === void 0 ? void 0 : formValues.GrandTotal),
                                            TotalDiscount: 0,
                                            OtherCharges: 0,
                                            TotalTax: 0,
                                            GrandTotal: parseFloat(formValues === null || formValues === void 0 ? void 0 : formValues.GrandTotal),
                                            ApprovedById: formValues === null || formValues === void 0 ? void 0 : formValues.ApprovedById,
                                            ValidTillDateTime: formValues === null || formValues === void 0 ? void 0 : formValues.ValidTillDateTime,
                                            Remarks: formValues === null || formValues === void 0 ? void 0 : formValues.Remarks,
                                            OrganizationId: UserOrganizationID,
                                            ParentOrganizationId: ParentOrganizationID,
                                            PersonId: formValues === null || formValues === void 0 || (_formValues$Customer4 = formValues.Customer) === null || _formValues$Customer4 === void 0 ? void 0 : _formValues$Customer4.PersonId,
                                            PersonContactPointId: null,
                                            CGST_Amount: 0,
                                            CGST_Percentage: 0,
                                            SGST_UTGST_Amount: 0,
                                            SGST_UTGST_Percentage: 0,
                                            IGST_Amount: 0,
                                            IGST_Percentage: 0,
                                            SystemName: 'ServiceContract',
                                            VehicleContractDetails: formValues === null || formValues === void 0 ? void 0 : formValues.VehicleContractDetails,
                                            InvoicePayment: {
                                                PaymentDate: dayjs(),
                                                PaymentDueDate: formValues === null || formValues === void 0 ? void 0 : formValues.PaymentDueDate,
                                                PaymentTermId: formValues === null || formValues === void 0 ? void 0 : formValues.PaymentTermId,
                                                PaymentModeId: formValues === null || formValues === void 0 ? void 0 : formValues.PaymentModeId,
                                                PaymentTypeId: formValues === null || formValues === void 0 ? void 0 : formValues.PaymentTypeId,
                                                Remarks: ""
                                            },
                                            AccountPosting: [{
                                                    AccountId: "",
                                                    DebitAmount: "",
                                                    CreditAmount: ""
                                                }],
                                            ImageAttachments: [{
                                                    AttachmentId: uploadRes === null || uploadRes === void 0 || (_uploadRes$payload6 = uploadRes.payload) === null || _uploadRes$payload6 === void 0 || (_uploadRes$payload6 = _uploadRes$payload6.value) === null || _uploadRes$payload6 === void 0 ? void 0 : _uploadRes$payload6.attachmentId
                                                }]
                                        });
                                        return [4 /*yield*/, dispatch(createAPI({
                                                key: ContractInvoiceKeys.ContractInvoiceUpsertKey,
                                                url: UpsertNewContractURL,
                                                request: JSIRequest
                                            }))];
                                    case 6:
                                        upsertRes = _a.sent();
                                        if (!(upsertRes !== null && upsertRes !== void 0 && (_upsertRes$payload3 = upsertRes.payload) !== null && _upsertRes$payload3 !== void 0 && (_upsertRes$payload3 = _upsertRes$payload3.value) !== null && _upsertRes$payload3 !== void 0 && _upsertRes$payload3.success)) return [3 /*break*/, 8];
                                        return [4 /*yield*/, dispatch(showSurface({
                                                type: 'Dialog',
                                                Component: InvoiceSavedPopup,
                                                componentProps: {
                                                    data: formValues,
                                                    resData: upsertRes === null || upsertRes === void 0 || (_upsertRes$payload4 = upsertRes.payload) === null || _upsertRes$payload4 === void 0 || (_upsertRes$payload4 = _upsertRes$payload4.value) === null || _upsertRes$payload4 === void 0 ? void 0 : _upsertRes$payload4.data
                                                }
                                            }))];
                                    case 7:
                                        upsertSuccess = _a.sent();
                                        if ((upsertSuccess === null || upsertSuccess === void 0 ? void 0 : upsertSuccess.payload) === 'goHome') {
                                            navigate('/contractSaleInvoice');
                                        }
                                        _a.label = 8;
                                    case 8: return [3 /*break*/, 10];
                                    case 9:
                                        error_2 = _a.sent();
                                        console.error("Error during attachment creation/upload:", error_2);
                                        return [3 /*break*/, 10];
                                    case 10: return [3 /*break*/, 12];
                                    case 11:
                                        dispatch(showNotification({
                                            isOpen: true,
                                            message: 'Signature is mandatory',
                                            type: "error"
                                        }));
                                        _a.label = 12;
                                    case 12: return [2 /*return*/];
                                }
                            });
                        }); }
                    }]
            }); }
        } : null];
    return /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        gridProps: {
            spacing: 0,
            bgcolor: 'secondary.50'
        },
        formData: formData,
        getFormAPI: getContractSaleOrderAPI,
        getRequest: {
            id: id
        },
        mode: id ? 'edit' : 'add',
        getKey: ContractInvoiceKeys.getCSI
    });
};
export default NewContractSaleInvoice;
